import React, {FC, useEffect, useState} from 'react'
import {useLocation} from 'react-router-dom'
import {ToastContainer} from 'react-toastify'
import {fetchData, formatNumber, getTranslatedValue, toasterrormsg} from '../../../reusable'
import {PageTitle} from '../../../_metronic/layout/core'
import Fancybox from '../Fancybox'
import {CarRentalDetailsHeader} from './CarRentalDetailsHeader'
import {toAbsoluteUrl} from '../../../_metronic/helpers'
import {Tr} from '../../../_metronic/i18n/Tr'
import clsx from 'clsx'
import { useLang } from '../../../_metronic/i18n/Metronici18n'

const CarRentalOverview: FC = () => {
  let t = Tr()
  const location = useLocation()
  const [tab, setTab] = useState('1') // 1,2,3,4,5,6,7
  const lang  = useLang()

  const carrentalId = (location.state as any)?.carrentalId || ''
  const [carRentalDetails, setCarRentalDetails] = useState([])
  const [qqsList, setQqsList] = useState([])

  // carRental Details api call
  const carRentalDetailsApiCall = async () => {
    var param: any = {
      carrentalId: String(carrentalId),
    }
    var response: any = await fetchData('vendor/public/carRentalDetail', param)

    if (response.status == '200') {
      setCarRentalDetails(response.data)
    } else {
      toasterrormsg(response.message)
    }
  }
  // for fancy box
  const opts = {
    fullScreen: {
      autoStart: true, // Auto-start in full-screen mode
    },
    Thumbs: false,
    // Other options...
  }
  const qqsListApiCall = async () => {
    var response: any = await fetchData('vendor/public/qqsList', {})
    if (response.status == '200') {
      const filterData = response.data.map((item: any) => ({label: item.name, value: item.qqsId}))
      setQqsList(filterData)
    } else {
      toasterrormsg(response.message)
    }
  }
  useEffect(() => {
    carRentalDetailsApiCall()
    qqsListApiCall()
  }, [])

  const formatTime = (time: string) => {
    const [hours, minutes] = time.split(':').map(Number)
    const period = hours >= 12 ? 'PM' : 'AM'
    const adjustedHours = hours % 12 || 12
    const formattedMinutes = minutes < 10 ? `0${minutes}` : minutes // Ensure minutes are two digits
    return `${adjustedHours}:${formattedMinutes} ${period}`
  }

  return (
    <>
      <PageTitle breadcrumbs={[]}>{t('Car Rental Overview')}</PageTitle>
      <ToastContainer />
      <CarRentalDetailsHeader />
      {carRentalDetails.map((carRental: any, index: any) => {
        var selectedQqs: any =
          qqsList.find((option: any) => option.value === carRental['qqs']) || null

        const createdDate = new Date(carRental['created'])

        // Add two years
        const createdDateTwoYearsLater = new Date(createdDate)
        createdDateTwoYearsLater.setFullYear(createdDate.getFullYear() + 2)

        // Check if dates are valid
        const isCreatedDateValid = !isNaN(createdDate.getTime())
        const isCreatedDateTwoYearsLaterValid = !isNaN(createdDateTwoYearsLater.getTime())

        // Parse availableDate into an array of objects
        const availableDates: any = carRental['availableDate']

        // Filter and map start dates for 'unavailable' type
        const unavailableDates: any = availableDates
          .filter((date: any) => date.type === 'unavailable')
          .map((date: any) =>
            new Date(date.start).toLocaleDateString('en-GB', {
              day: '2-digit',
              month: 'long',
              year: 'numeric',
            })
          )
        return (
          <div className='form' key={index}>
            {/* <!--begin::Card--> */}
            <div className='card'>
              {/* <!--begin::Card header--> */}
              <div className='card-header'>
                {/* <!--begin::Card header--> */}
                <div className='card-title fs-3 fw-bold'>{t('Basic Info')} </div>
                {/* <!--end::Card header--> */}
              </div>
              {/* <!--end::Card header--> */}
              {/* <!--begin::Card body--> */}
              <div className='card-body'>
                {carRental['en_supplierName'] ? (
                  <>
                    {/* <!--begin::Row--> */}
                    <div className='row mb-8'>
                      {/* <!--begin::Col--> */}
                      <div className='col-xl-3'>
                        <div className='fs-6 fw-bold mt-2 mb-3'>{t('Supplier Name (English)')}</div>
                      </div>
                      {/* <!--end::Col--> */}

                      {/* <!--begin::Col--> */}
                      <div className='col-xl-9'>
                        {/* <!--begin::Progress--> */}
                        <div className='d-flex flex-column'>
                          <div className=' fw-semibold text-gray-600 mt-3'>
                            <div
                              dangerouslySetInnerHTML={{
                                __html: carRental['en_supplierName'],
                              }}
                            ></div>
                          </div>
                        </div>
                        {/* <!--end::Progress--> */}
                      </div>
                      {/* <!--end::Col--> */}
                    </div>
                    {/* <!--end::Row--> */}
                  </>
                ) : (
                  ''
                )}
                {carRental['ru_supplierName'] ? (
                  <>
                    {/* <!--begin::Row--> */}
                    <div className='row mb-8'>
                      {/* <!--begin::Col--> */}
                      <div className='col-xl-3'>
                        <div className='fs-6 fw-bold mt-2 mb-3'>{t('Supplier Name (Russian)')}</div>
                      </div>
                      {/* <!--end::Col--> */}

                      {/* <!--begin::Col--> */}
                      <div className='col-xl-9'>
                        {/* <!--begin::Progress--> */}
                        <div className='d-flex flex-column'>
                          <div className=' fw-semibold text-gray-600 mt-3'>
                            <div
                              dangerouslySetInnerHTML={{
                                __html: carRental['ru_supplierName'],
                              }}
                            ></div>
                          </div>
                        </div>
                        {/* <!--end::Progress--> */}
                      </div>
                      {/* <!--end::Col--> */}
                    </div>
                    {/* <!--end::Row--> */}
                  </>
                ) : (
                  ''
                )}
                {carRental['uz_supplierName'] ? (
                  <>
                    {/* <!--begin::Row--> */}
                    <div className='row mb-8'>
                      {/* <!--begin::Col--> */}
                      <div className='col-xl-3'>
                        <div className='fs-6 fw-bold mt-2 mb-3'>{t('Supplier Name (Uzbek)')}</div>
                      </div>
                      {/* <!--end::Col--> */}

                      {/* <!--begin::Col--> */}
                      <div className='col-xl-9'>
                        {/* <!--begin::Progress--> */}
                        <div className='d-flex flex-column'>
                          <div className=' fw-semibold text-gray-600 mt-3'>
                            <div
                              dangerouslySetInnerHTML={{
                                __html: carRental['uz_supplierName'],
                              }}
                            ></div>
                          </div>
                        </div>
                        {/* <!--end::Progress--> */}
                      </div>
                      {/* <!--end::Col--> */}
                    </div>
                    {/* <!--end::Row--> */}
                  </>
                ) : (
                  ''
                )}
                {carRental['propertyType'] ? (
                  <>
                    {/* <!--begin::Row--> */}
                    <div className='row mb-8'>
                      {/* <!--begin::Col--> */}
                      <div className='col-xl-3'>
                        <div className='fs-6 fw-bold mt-2 mb-3'>{t('Proprety Type')}</div>
                      </div>
                      {/* <!--end::Col--> */}

                      {/* <!--begin::Col--> */}
                      <div className='col-xl-9'>
                        {/* <!--begin::Progress--> */}
                        <div className='d-flex flex-column'>
                          <div className=' fw-semibold text-gray-600 mt-3'>
                            <div
                              dangerouslySetInnerHTML={{
                                __html: carRental['propertyType'],
                              }}
                            ></div>
                          </div>
                        </div>
                        {/* <!--end::Progress--> */}
                      </div>
                      {/* <!--end::Col--> */}
                    </div>
                    {/* <!--end::Row--> */}
                  </>
                ) : (
                  ''
                )}
                {carRental['hotelClass'] ? (
                  <>
                    {/* <!--begin::Row--> */}
                    <div className='row mb-8'>
                      {/* <!--begin::Col--> */}
                      <div className='col-xl-3'>
                        <div className='fs-6 fw-bold mt-2 mb-3'>{t('Proprety Class')}</div>
                      </div>
                      {/* <!--end::Col--> */}

                      {/* <!--begin::Col--> */}
                      <div className='col-xl-9'>
                        {/* <!--begin::Progress--> */}
                        <div className='d-flex flex-column'>
                          <div className=' fw-semibold text-gray-600 mt-3'>
                            <div>
                              {carRental['hotelClass']} {t('Stars')}
                            </div>
                          </div>
                        </div>
                        {/* <!--end::Progress--> */}
                      </div>
                      {/* <!--end::Col--> */}
                    </div>
                    {/* <!--end::Row--> */}
                  </>
                ) : (
                  ''
                )}

                {carRental['contact_person_name'] ? (
                  <>
                    {/* <!--begin::Row--> */}
                    <div className='row mb-8'>
                      {/* <!--begin::Col--> */}
                      <div className='col-xl-3'>
                        <div className='fs-6 fw-bold mt-2 mb-3'>{t('Contact Person Name')}</div>
                      </div>
                      {/* <!--end::Col--> */}

                      {/* <!--begin::Col--> */}
                      <div className='col-xl-9'>
                        {/* <!--begin::Progress--> */}
                        <div className='d-flex flex-column'>
                          <div className=' fw-semibold text-gray-600 mt-3'>
                            <div>{carRental['contact_person_name']} </div>
                          </div>
                        </div>
                        {/* <!--end::Progress--> */}
                      </div>
                      {/* <!--end::Col--> */}
                    </div>
                    {/* <!--end::Row--> */}
                  </>
                ) : (
                  ''
                )}
                {carRental['email'] ? (
                  <>
                    {/* <!--begin::Row--> */}
                    <div className='row mb-8'>
                      {/* <!--begin::Col--> */}
                      <div className='col-xl-3'>
                        <div className='fs-6 fw-bold mt-2 mb-3'>{t('Email')}</div>
                      </div>
                      {/* <!--end::Col--> */}

                      {/* <!--begin::Col--> */}
                      <div className='col-xl-9'>
                        {/* <!--begin::Progress--> */}
                        <div className='d-flex flex-column'>
                          <div className=' fw-semibold text-gray-600 mt-3'>
                            <div>{carRental['email']} </div>
                          </div>
                        </div>
                        {/* <!--end::Progress--> */}
                      </div>
                      {/* <!--end::Col--> */}
                    </div>
                    {/* <!--end::Row--> */}
                  </>
                ) : (
                  ''
                )}
                {carRental['phoneNo'] ? (
                  <>
                    {/* <!--begin::Row--> */}
                    <div className='row mb-8'>
                      {/* <!--begin::Col--> */}
                      <div className='col-xl-3'>
                        <div className='fs-6 fw-bold mt-2 mb-3'>{t('Mobile Number')}</div>
                      </div>
                      {/* <!--end::Col--> */}

                      {/* <!--begin::Col--> */}
                      <div className='col-xl-9'>
                        {/* <!--begin::Progress--> */}
                        <div className='d-flex flex-column'>
                          <div className=' fw-semibold text-gray-600 mt-3'>
                            <div>{carRental['phoneNo']} </div>
                          </div>
                        </div>
                        {/* <!--end::Progress--> */}
                      </div>
                      {/* <!--end::Col--> */}
                    </div>
                    {/* <!--end::Row--> */}
                  </>
                ) : (
                  ''
                )}
                {carRental['socialMediaChannels'] && carRental['socialMediaChannels'].length > 0 && (
                  <div className='row mb-8'>
                    {/* <!--begin::Col--> */}
                    <div className='col-xl-3'>
                      <div className='fs-6 fw-bold mt-2 mb-3'>{t('Social Media Links')}</div>
                    </div>
                    {/* <!--end::Col--> */}

                    {/* <!--begin::Col--> */}
                    <div className='col-xl-9'>
                      {/* <!--begin::Progress--> */}
                      <div className='d-flex flex-column'>
                        <div className='fw-semibold text-gray-600 mt-3'>
                          {/* Render each social media type and link on a new line */}
                          {carRental['socialMediaChannels']
                            .filter(
                              (channel: any) =>
                                channel['socialMediaType'] && channel['socialMediaLink']
                            ) // Filter out channels without type or link
                            .map((channel: any, index: number) => (
                              <p key={index}>
                                <strong>{channel['socialMediaType']}:</strong>
                                {'  '}
                                <a
                                  href={channel['socialMediaLink']}
                                  target='_blank'
                                  rel='noopener noreferrer'
                                >
                                  {channel['socialMediaLink']}
                                </a>
                              </p>
                            ))}
                        </div>
                      </div>
                      {/* <!--end::Progress--> */}
                    </div>
                    {/* <!--end::Col--> */}
                  </div>
                )}
                <div className='col-xl-3 border-bottom border-light border-2 w-100 mb-5 mt-5'>
                  <div className='fs-3 fw-bold mb-5 '>{t('Property Location')}</div>
                </div>
                {carRental['location'] ? (
                  <>
                    {/* <!--begin::Row--> */}
                    <div className='row mb-8'>
                      {/* <!--begin::Col--> */}
                      <div className='col-xl-3'>
                        <div className='fs-6 fw-bold mt-2 mb-3'>{t('Location')}</div>
                      </div>
                      {/* <!--end::Col--> */}

                      {/* <!--begin::Col--> */}
                      <div className='col-xl-9'>
                        {/* <!--begin::Progress--> */}
                        <div className='d-flex flex-column'>
                          <div className=' fw-semibold text-gray-600 mt-3'>
                            <div>{carRental['location']} </div>
                          </div>
                        </div>
                        {/* <!--end::Progress--> */}
                      </div>
                      {/* <!--end::Col--> */}
                    </div>
                    {/* <!--end::Row--> */}
                  </>
                ) : (
                  ''
                )}
                {carRental['vendorDetails'] &&
                  carRental['vendorDetails'].map((vendordetail: any) => {
                    return (
                      <>
                        {vendordetail['country'] &&
                          vendordetail['country'].map((country: any) => {
                            return (
                              <>
                                {country['name'] ? (
                                  <>
                                    {/* <!--begin::Row--> */}
                                    <div className='row mb-8'>
                                      {/* <!--begin::Col--> */}
                                      <div className='col-xl-3'>
                                        <div className='fs-6 fw-bold mt-2 mb-3'>{t('Country')}</div>
                                      </div>
                                      {/* <!--end::Col--> */}

                                      {/* <!--begin::Col--> */}
                                      <div className='col-xl-9'>
                                        {/* <!--begin::Progress--> */}
                                        <div className='d-flex flex-column'>
                                          <div className=' fw-semibold text-gray-600 mt-3'>
                                            <div>{country['name']}</div>
                                          </div>
                                        </div>
                                        {/* <!--end::Progress--> */}
                                      </div>
                                      {/* <!--end::Col--> */}
                                    </div>
                                    {/* <!--end::Row--> */}
                                  </>
                                ) : (
                                  ''
                                )}
                              </>
                            )
                          })}

                        {vendordetail['addressline1'] ? (
                          <>
                            {/* <!--begin::Row--> */}
                            <div className='row mb-8'>
                              {/* <!--begin::Col--> */}
                              <div className='col-xl-3'>
                                <div className='fs-6 fw-bold mt-2 mb-3'>{t('Address Line 1')}</div>
                              </div>
                              {/* <!--end::Col--> */}

                              {/* <!--begin::Col--> */}
                              <div className='col-xl-9'>
                                {/* <!--begin::Progress--> */}
                                <div className='d-flex flex-column'>
                                  <div className=' fw-semibold text-gray-600 mt-3'>
                                    <div>{vendordetail['addressline1']}</div>
                                  </div>
                                </div>
                                {/* <!--end::Progress--> */}
                              </div>
                              {/* <!--end::Col--> */}
                            </div>
                            {/* <!--end::Row--> */}
                          </>
                        ) : (
                          ''
                        )}

                        {vendordetail['addressline2'] ? (
                          <>
                            {/* <!--begin::Row--> */}
                            <div className='row mb-8'>
                              {/* <!--begin::Col--> */}
                              <div className='col-xl-3'>
                                <div className='fs-6 fw-bold mt-2 mb-3'>{t('Address Line 2')}</div>
                              </div>
                              {/* <!--end::Col--> */}

                              {/* <!--begin::Col--> */}
                              <div className='col-xl-9'>
                                {/* <!--begin::Progress--> */}
                                <div className='d-flex flex-column'>
                                  <div className=' fw-semibold text-gray-600 mt-3'>
                                    <div>{vendordetail['addressline2']}</div>
                                  </div>
                                </div>
                                {/* <!--end::Progress--> */}
                              </div>
                              {/* <!--end::Col--> */}
                            </div>
                            {/* <!--end::Row--> */}
                          </>
                        ) : (
                          ''
                        )}
                        {vendordetail['region'] ? (
                          <>
                            {/* <!--begin::Row--> */}
                            <div className='row mb-8'>
                              {/* <!--begin::Col--> */}
                              <div className='col-xl-3'>
                                <div className='fs-6 fw-bold mt-2 mb-3'>{t('Region')}</div>
                              </div>
                              {/* <!--end::Col--> */}

                              {/* <!--begin::Col--> */}
                              <div className='col-xl-9'>
                                {/* <!--begin::Progress--> */}
                                <div className='d-flex flex-column'>
                                  <div className=' fw-semibold text-gray-600 mt-3'>
                                    <div>{getTranslatedValue(  lang, vendordetail['regionDetail'][0] , "_name")}</div>
                                  </div>
                                </div>
                                {/* <!--end::Progress--> */}
                              </div>
                              {/* <!--end::Col--> */}
                            </div>
                            {/* <!--end::Row--> */}
                          </>
                        ) : (
                          ''
                        )}
                        {vendordetail['zipcode'] ? (
                          <>
                            {/* <!--begin::Row--> */}
                            <div className='row mb-8'>
                              {/* <!--begin::Col--> */}
                              <div className='col-xl-3'>
                                <div className='fs-6 fw-bold mt-2 mb-3'>{t('Zip Code')}</div>
                              </div>
                              {/* <!--end::Col--> */}

                              {/* <!--begin::Col--> */}
                              <div className='col-xl-9'>
                                {/* <!--begin::Progress--> */}
                                <div className='d-flex flex-column'>
                                  <div className=' fw-semibold text-gray-600 mt-3'>
                                    <div>{vendordetail['zipcode']}</div>
                                  </div>
                                </div>
                                {/* <!--end::Progress--> */}
                              </div>
                              {/* <!--end::Col--> */}
                            </div>
                            {/* <!--end::Row--> */}
                          </>
                        ) : (
                          ''
                        )}
                      </>
                    )
                  })}
                {carRental['en_basicName'] != '' ? (
                  <div className='col-xl-3 border-bottom border-light border-2 w-100 mb-5 mt-5'>
                    <div className='fs-3 fw-bold mb-5 '>{t('Insurance')}</div>
                  </div>
                ) : (
                  ''
                )}
                <span className='text-gray-400 fw-bold pt-2 fs-4'>{t('Basic Plan')}</span>

                {carRental['en_basicName'] ? (
                  <>
                    {/* <!--begin::Row--> */}
                    <div className='row mb-8'>
                      {/* <!--begin::Col--> */}
                      <div className='col-xl-3'>
                        <div className='fs-6 fw-bold mt-2 mb-3'>{t('Basic Plan Name English')}</div>
                      </div>
                      {/* <!--end::Col--> */}

                      {/* <!--begin::Col--> */}
                      <div className='col-xl-9'>
                        {/* <!--begin::Progress--> */}
                        <div className='d-flex flex-column'>
                          <div className=' fw-semibold text-gray-600 mt-3'>
                            <div
                              dangerouslySetInnerHTML={{
                                __html: carRental['en_basicName'],
                              }}
                            ></div>
                          </div>
                        </div>
                        {/* <!--end::Progress--> */}
                      </div>
                      {/* <!--end::Col--> */}
                    </div>
                    {/* <!--end::Row--> */}
                  </>
                ) : (
                  ''
                )}
                {carRental['ru_basicName'] ? (
                  <>
                    {/* <!--begin::Row--> */}
                    <div className='row mb-8'>
                      {/* <!--begin::Col--> */}
                      <div className='col-xl-3'>
                        <div className='fs-6 fw-bold mt-2 mb-3'>{t('Basic Plan Name Russian')}</div>
                      </div>
                      {/* <!--end::Col--> */}

                      {/* <!--begin::Col--> */}
                      <div className='col-xl-9'>
                        {/* <!--begin::Progress--> */}
                        <div className='d-flex flex-column'>
                          <div className=' fw-semibold text-gray-600 mt-3'>
                            <div
                              dangerouslySetInnerHTML={{
                                __html: carRental['ru_basicName'],
                              }}
                            ></div>
                          </div>
                        </div>
                        {/* <!--end::Progress--> */}
                      </div>
                      {/* <!--end::Col--> */}
                    </div>
                    {/* <!--end::Row--> */}
                  </>
                ) : (
                  ''
                )}
                {carRental['uz_basicName'] ? (
                  <>
                    {/* <!--begin::Row--> */}
                    <div className='row mb-8'>
                      {/* <!--begin::Col--> */}
                      <div className='col-xl-3'>
                        <div className='fs-6 fw-bold mt-2 mb-3'>{t('Basic Plan Name Uzbek')}</div>
                      </div>
                      {/* <!--end::Col--> */}

                      {/* <!--begin::Col--> */}
                      <div className='col-xl-9'>
                        {/* <!--begin::Progress--> */}
                        <div className='d-flex flex-column'>
                          <div className=' fw-semibold text-gray-600 mt-3'>
                            <div
                              dangerouslySetInnerHTML={{
                                __html: carRental['uz_basicName'],
                              }}
                            ></div>
                          </div>
                        </div>
                        {/* <!--end::Progress--> */}
                      </div>
                      {/* <!--end::Col--> */}
                    </div>
                    {/* <!--end::Row--> */}
                  </>
                ) : (
                  ''
                )}
                {carRental['basicPrice'] ? (
                  <>
                    {/* <!--begin::Row--> */}
                    <div className='row mb-8'>
                      {/* <!--begin::Col--> */}
                      <div className='col-xl-3'>
                        <div className='fs-6 fw-bold mt-2 mb-3'>{t('Price (By Day)')}</div>
                      </div>
                      {/* <!--end::Col--> */}

                      {/* <!--begin::Col--> */}
                      <div className='col-xl-9'>
                        {/* <!--begin::Progress--> */}
                        <div className='d-flex flex-column'>
                          <div className=' fw-semibold text-gray-600 mt-3'>
                            {formatNumber(parseFloat(carRental['basicPrice']))}{' '}
                          </div>
                        </div>
                        {/* <!--end::Progress--> */}
                      </div>
                      {/* <!--end::Col--> */}
                    </div>
                    {/* <!--end::Row--> */}
                  </>
                ) : (
                  ''
                )}
                {carRental['basicIncluded'].length > 0 ? (
                  <div className='col-xl-3 mb-5 mt-5'>
                    <div className='fs-4 fw-bold mb-5 text-gray-400'>{t('Basic Plan Coverage')}</div>
                  </div>
                ) : (
                  ''
                )}

                {carRental['basicIncluded'] && carRental['basicIncluded'].length > 0 && (
                  <>
                    <div className='section'>
                      <div className='row mb-8'>
                        <div className='col-xl-9'>
                          <div className='d-flex flex-column'>
                            <span className='fw-bold'>{t("Included")}:</span>
                            {carRental['basicIncluded']
                              .filter((item: any) => item['status'] === true)
                              .map((item: any, index: any) => (
                                <div key={index} className='item-container mt-3'>
                                  <div className='item'>
                                    <span className='fw-bold'>{t('English Title')}:</span>{' '}
                                    {item['en_title']}
                                  </div>
                                  <div className='item'>
                                    <span className='fw-bold'>{t('Russian Title')}:</span>{' '}
                                    {item['ru_title']}
                                  </div>
                                  <div className='item'>
                                    <span className='fw-bold'>{t('Uzbek Title')}:</span>{' '}
                                    {item['uz_title']}
                                  </div>
                                </div>
                              ))}
                          </div>
                        </div>
                      </div>
                    </div>

                    <div className='section'>
                      <div className='row mb-8'>
                        <div className='col-xl-9'>
                          <div className='d-flex flex-column'>
                            <span className='fw-bold'>{t('Not Included:')}</span>
                            {carRental['basicIncluded']
                              .filter((item: any) => item['status'] === false)
                              .map((item: any, index: any) => (
                                <div key={index} className='item-container mt-3'>
                                  <div className='item'>
                                    <span className='fw-bold'>{t('English Title')}:</span>{' '}
                                    {item['en_title']}
                                  </div>
                                  <div className='item'>
                                    <span className='fw-bold'>{t('Russian Title')}:</span>{' '}
                                    {item['ru_title']}
                                  </div>
                                  <div className='item'>
                                    <span className='fw-bold'>{t('Uzbek Title')}:</span>{' '}
                                    {item['uz_title']}
                                  </div>
                                </div>
                              ))}
                          </div>
                        </div>
                      </div>
                    </div>
                  </>
                )}

                <span className='text-gray-400 fw-bold pb-2 fs-4'>{t('Premium Plan')}</span>

                {carRental['premiumIncluded'] && carRental['premiumIncluded'].length > 0 && (
                  <>
                    {carRental['en_premiumName'] && (
                      <div className='row mb-8'>
                        {/* <!--begin::Col--> */}
                        <div className='col-xl-3'>
                          <div className='fs-6 fw-bold mt-2 mb-3'>
                            {t('Premium Plan Name English')}
                          </div>
                        </div>
                        {/* <!--end::Col--> */}

                        {/* <!--begin::Col--> */}
                        <div className='col-xl-9'>
                          {/* <!--begin::Progress--> */}
                          <div className='d-flex flex-column'>
                            <div className=' fw-semibold text-gray-600 mt-3'>
                              <div
                                dangerouslySetInnerHTML={{__html: carRental['en_premiumName']}}
                              ></div>
                            </div>
                          </div>
                          {/* <!--end::Progress--> */}
                        </div>
                        {/* <!--end::Col--> */}
                      </div>
                    )}
                    {carRental['ru_premiumName'] && (
                      <div className='row mb-8'>
                        {/* <!--begin::Col--> */}
                        <div className='col-xl-3'>
                          <div className='fs-6 fw-bold mt-2 mb-3'>
                            {t('Premium Plan Name Russian')}
                          </div>
                        </div>
                        {/* <!--end::Col--> */}

                        {/* <!--begin::Col--> */}
                        <div className='col-xl-9'>
                          {/* <!--begin::Progress--> */}
                          <div className='d-flex flex-column'>
                            <div className=' fw-semibold text-gray-600 mt-3'>
                              <div
                                dangerouslySetInnerHTML={{
                                  __html: carRental['ru_premiumName'],
                                }}
                              ></div>
                            </div>
                          </div>
                          {/* <!--end::Progress--> */}
                        </div>
                        {/* <!--end::Col--> */}
                      </div>
                    )}
                    {carRental['uz_premiumName'] && (
                      <div className='row mb-8'>
                        {/* <!--begin::Col--> */}
                        <div className='col-xl-3'>
                          <div className='fs-6 fw-bold mt-2 mb-3'>
                            {t('Premium Plan Name Uzbek')}{' '}
                          </div>
                        </div>
                        {/* <!--end::Col--> */}

                        {/* <!--begin::Col--> */}
                        <div className='col-xl-9'>
                          {/* <!--begin::Progress--> */}
                          <div className='d-flex flex-column'>
                            <div className=' fw-semibold text-gray-600 mt-3'>
                              <div
                                dangerouslySetInnerHTML={{__html: carRental['uz_premiumName']}}
                              ></div>
                            </div>
                          </div>
                          {/* <!--end::Progress--> */}
                        </div>
                        {/* <!--end::Col--> */}
                      </div>
                    )}

                    {carRental['premiumPrice'] && (
                      <div className='row mb-8'>
                        {/* <!--begin::Col--> */}
                        <div className='col-xl-3'>
                          <div className='fs-6 fw-bold mt-2 mb-3'>{t('Premium Price')}</div>
                        </div>
                        {/* <!--end::Col--> */}

                        {/* <!--begin::Col--> */}
                        <div className='col-xl-9'>
                          {/* <!--begin::Progress--> */}
                          <div className='d-flex flex-column'>
                            <div className=' fw-semibold text-gray-600 mt-3'>
                              {formatNumber(parseFloat(carRental['premiumPrice']))}{' '}
                            </div>
                          </div>
                          {/* <!--end::Progress--> */}
                        </div>
                        {/* <!--end::Col--> */}
                      </div>
                    )}
                  </>
                )}

                {carRental['premiumIncluded'].length > 0 ? (
                  <div className='col-xl-3 mb-5 mt-5'>
                    <div className='fs-4 fw-bold mb-5 text-gray-400'>{t('Premium Plan Coverage')}</div>
                  </div>
                ) : (
                  ''
                )}

                {carRental['premiumIncluded'] && carRental['premiumIncluded'].length > 0 && (
                  <>
                    <div className='section'>
                      <div className='row mb-8'>
                        <div className='col-xl-9'>
                          <div className='d-flex flex-column'>
                            <span className='fw-bold'>{t('Included')}:</span>
                            {carRental['premiumIncluded']
                              .filter((item: any) => item['status'] === true)
                              .map((item: any, index: any) => (
                                <div key={index} className='item-container mt-3'>
                                  <div className='item'>
                                    <span className='fw-bold'>{t('English Title')}:</span>{' '}
                                    {item['en_title']}
                                  </div>
                                  <div className='item'>
                                    <span className='fw-bold'>{t('Russian Title')}:</span>{' '}
                                    {item['ru_title']}
                                  </div>
                                  <div className='item'>
                                    <span className='fw-bold'>{t('Uzbek Title')}:</span>{' '}
                                    {item['uz_title']}
                                  </div>
                                </div>
                              ))}
                          </div>
                        </div>
                      </div>
                    </div>

                    <div className='section'>
                      <div className='row mb-8'>
                        <div className='col-xl-9'>
                          <div className='d-flex flex-column'>
                            <span className='fw-bold'>{t('Not Included:')}</span>
                            {carRental['premiumIncluded']
                              .filter((item: any) => item['status'] === false)
                              .map((item: any, index: any) => (
                                <div key={index} className='item-container mt-3'>
                                  <div className='item'>
                                    <span className='fw-bold'>{t('English Title')}:</span>{' '}
                                    {item['en_title']}
                                  </div>
                                  <div className='item'>
                                    <span className='fw-bold'>{t('Russian Title')}:</span>{' '}
                                    {item['ru_title']}
                                  </div>
                                  <div className='item'>
                                    <span className='fw-bold'>{t('Uzbek Title')}:</span>{' '}
                                    {item['uz_title']}
                                  </div>
                                </div>
                              ))}
                          </div>
                        </div>
                      </div>
                    </div>
                  </>
                )}
                {carRental['en_passport'] != '' ? (
                  <div className='col-xl-3 border-bottom border-light border-2 w-100 mb-5 mt-5'>
                    <div className='fs-3 fw-bold mb-5 '>{t('Required Documents')}</div>
                  </div>
                ) : (
                  ''
                )}
                {carRental['en_passport'] ? (
                  <>
                    {/* <!--begin::Row--> */}
                    <div className='row mb-8'>
                      {/* <!--begin::Col--> */}
                      <div className='col-xl-3'>
                        <div className='fs-6 fw-bold mt-2 mb-3'>{t('ID/Passport (English)')}</div>
                      </div>
                      {/* <!--end::Col--> */}

                      {/* <!--begin::Col--> */}
                      <div className='col-xl-9'>
                        {/* <!--begin::Progress--> */}
                        <div className='d-flex flex-column'>
                          <div className=' fw-semibold text-gray-600 mt-3'>
                            <div
                              dangerouslySetInnerHTML={{
                                __html: carRental['en_passport'],
                              }}
                            ></div>
                          </div>
                        </div>
                        {/* <!--end::Progress--> */}
                      </div>
                      {/* <!--end::Col--> */}
                    </div>
                    {/* <!--end::Row--> */}
                  </>
                ) : (
                  ''
                )}
                {carRental['ru_passport'] ? (
                  <>
                    {/* <!--begin::Row--> */}
                    <div className='row mb-8'>
                      {/* <!--begin::Col--> */}
                      <div className='col-xl-3'>
                        <div className='fs-6 fw-bold mt-2 mb-3'>{t('ID/Passport (Russian)')}</div>
                      </div>
                      {/* <!--end::Col--> */}

                      {/* <!--begin::Col--> */}
                      <div className='col-xl-9'>
                        {/* <!--begin::Progress--> */}
                        <div className='d-flex flex-column'>
                          <div className=' fw-semibold text-gray-600 mt-3'>
                            <div
                              dangerouslySetInnerHTML={{
                                __html: carRental['ru_passport'],
                              }}
                            ></div>
                          </div>
                        </div>
                        {/* <!--end::Progress--> */}
                      </div>
                      {/* <!--end::Col--> */}
                    </div>
                    {/* <!--end::Row--> */}
                  </>
                ) : (
                  ''
                )}
                {carRental['uz_passport'] ? (
                  <>
                    {/* <!--begin::Row--> */}
                    <div className='row mb-8'>
                      {/* <!--begin::Col--> */}
                      <div className='col-xl-3'>
                        <div className='fs-6 fw-bold mt-2 mb-3'>{t('ID/Passport (Uzbek)')}</div>
                      </div>
                      {/* <!--end::Col--> */}

                      {/* <!--begin::Col--> */}
                      <div className='col-xl-9'>
                        {/* <!--begin::Progress--> */}
                        <div className='d-flex flex-column'>
                          <div className=' fw-semibold text-gray-600 mt-3'>
                            <div
                              dangerouslySetInnerHTML={{
                                __html: carRental['uz_passport'],
                              }}
                            ></div>
                          </div>
                        </div>
                        {/* <!--end::Progress--> */}
                      </div>
                      {/* <!--end::Col--> */}
                    </div>
                    {/* <!--end::Row--> */}
                  </>
                ) : (
                  ''
                )}
                {carRental['en_drivingLincense'] ? (
                  <>
                    {/* <!--begin::Row--> */}
                    <div className='row mb-8'>
                      {/* <!--begin::Col--> */}
                      <div className='col-xl-3'>
                        <div className='fs-6 fw-bold mt-2 mb-3'>{t('Driving License English')}</div>
                      </div>
                      {/* <!--end::Col--> */}

                      {/* <!--begin::Col--> */}
                      <div className='col-xl-9'>
                        {/* <!--begin::Progress--> */}
                        <div className='d-flex flex-column'>
                          <div className=' fw-semibold text-gray-600 mt-3'>
                            <div
                              dangerouslySetInnerHTML={{
                                __html: carRental['en_drivingLincense'],
                              }}
                            ></div>
                          </div>
                        </div>
                        {/* <!--end::Progress--> */}
                      </div>
                      {/* <!--end::Col--> */}
                    </div>
                    {/* <!--end::Row--> */}
                  </>
                ) : (
                  ''
                )}
                {carRental['ru_drivingLincense'] ? (
                  <>
                    {/* <!--begin::Row--> */}
                    <div className='row mb-8'>
                      {/* <!--begin::Col--> */}
                      <div className='col-xl-3'>
                        <div className='fs-6 fw-bold mt-2 mb-3'>{t('Driving License Russian')}</div>
                      </div>
                      {/* <!--end::Col--> */}

                      {/* <!--begin::Col--> */}
                      <div className='col-xl-9'>
                        {/* <!--begin::Progress--> */}
                        <div className='d-flex flex-column'>
                          <div className=' fw-semibold text-gray-600 mt-3'>
                            <div
                              dangerouslySetInnerHTML={{
                                __html: carRental['ru_drivingLincense'],
                              }}
                            ></div>
                          </div>
                        </div>
                        {/* <!--end::Progress--> */}
                      </div>
                      {/* <!--end::Col--> */}
                    </div>
                    {/* <!--end::Row--> */}
                  </>
                ) : (
                  ''
                )}
                {carRental['uz_drivingLincense'] ? (
                  <>
                    {/* <!--begin::Row--> */}
                    <div className='row mb-8'>
                      {/* <!--begin::Col--> */}
                      <div className='col-xl-3'>
                        <div className='fs-6 fw-bold mt-2 mb-3'>{t('Driving License Uzbek')}</div>
                      </div>
                      {/* <!--end::Col--> */}

                      {/* <!--begin::Col--> */}
                      <div className='col-xl-9'>
                        {/* <!--begin::Progress--> */}
                        <div className='d-flex flex-column'>
                          <div className=' fw-semibold text-gray-600 mt-3'>
                            <div
                              dangerouslySetInnerHTML={{
                                __html: carRental['uz_drivingLincense'],
                              }}
                            ></div>
                          </div>
                        </div>
                        {/* <!--end::Progress--> */}
                      </div>
                      {/* <!--end::Col--> */}
                    </div>
                    {/* <!--end::Row--> */}
                  </>
                ) : (
                  ''
                )}
                {carRental['en_creditCardinfo'] ? (
                  <>
                    {/* <!--begin::Row--> */}
                    <div className='row mb-8'>
                      {/* <!--begin::Col--> */}
                      <div className='col-xl-3'>
                        <div className='fs-6 fw-bold mt-2 mb-3'>
                          {t('Payment Card Details English')}
                        </div>
                      </div>
                      {/* <!--end::Col--> */}

                      {/* <!--begin::Col--> */}
                      <div className='col-xl-9'>
                        {/* <!--begin::Progress--> */}
                        <div className='d-flex flex-column'>
                          <div className=' fw-semibold text-gray-600 mt-3'>
                            <div
                              dangerouslySetInnerHTML={{
                                __html: carRental['en_creditCardinfo'],
                              }}
                            ></div>
                          </div>
                        </div>
                        {/* <!--end::Progress--> */}
                      </div>
                      {/* <!--end::Col--> */}
                    </div>
                    {/* <!--end::Row--> */}
                  </>
                ) : (
                  ''
                )}
                {carRental['ru_creditCardinfo'] ? (
                  <>
                    {/* <!--begin::Row--> */}
                    <div className='row mb-8'>
                      {/* <!--begin::Col--> */}
                      <div className='col-xl-3'>
                        <div className='fs-6 fw-bold mt-2 mb-3'>
                          {t('Payment Card Details Russian')}
                        </div>
                      </div>
                      {/* <!--end::Col--> */}

                      {/* <!--begin::Col--> */}
                      <div className='col-xl-9'>
                        {/* <!--begin::Progress--> */}
                        <div className='d-flex flex-column'>
                          <div className=' fw-semibold text-gray-600 mt-3'>
                            <div
                              dangerouslySetInnerHTML={{
                                __html: carRental['ru_creditCardinfo'],
                              }}
                            ></div>
                          </div>
                        </div>
                        {/* <!--end::Progress--> */}
                      </div>
                      {/* <!--end::Col--> */}
                    </div>
                    {/* <!--end::Row--> */}
                  </>
                ) : (
                  ''
                )}
                {carRental['uz_creditCardinfo'] ? (
                  <>
                    {/* <!--begin::Row--> */}
                    <div className='row mb-8'>
                      {/* <!--begin::Col--> */}
                      <div className='col-xl-3'>
                        <div className='fs-6 fw-bold mt-2 mb-3'>{t('Payment Card Details Uzbek')}</div>
                      </div>
                      {/* <!--end::Col--> */}

                      {/* <!--begin::Col--> */}
                      <div className='col-xl-9'>
                        {/* <!--begin::Progress--> */}
                        <div className='d-flex flex-column'>
                          <div className=' fw-semibold text-gray-600 mt-3'>
                            <div
                              dangerouslySetInnerHTML={{
                                __html: carRental['uz_creditCardinfo'],
                              }}
                            ></div>
                          </div>
                        </div>
                        {/* <!--end::Progress--> */}
                      </div>
                      {/* <!--end::Col--> */}
                    </div>
                    {/* <!--end::Row--> */}
                  </>
                ) : (
                  ''
                )}

                {carRental['customeDocument'].length > 0 ? (
                  <div className='col-xl-3 mb-5 mt-5'>
                    <div className='fs-3 fw-bold mb-5 '>{t('Custom Doc')}</div>
                  </div>
                ) : (
                  ''
                )}
                <div className='custom-docs-container'>
                  {carRental['customeDocument'] &&
                    carRental['customeDocument'].length > 0 &&
                    carRental['customeDocument'].map((item: any, index: any) => {
                      return (
                        <div key={index} className='custom-docs-item'>
                          {item.en_title && (
                            <div className='custom-docs-block'>
                              <div className='col-xl-3 w-30'>
                                <div className='fs-6 fw-bold mt-2 mb-34'>
                                  {t('Custom Docs English Title :')}
                                </div>
                              </div>
                              <div className='col-xl-9'>
                                <div className='d-flex flex-column'>
                                  <div className='fw-semibold text-gray-600 '>
                                    <div dangerouslySetInnerHTML={{__html: item['en_title']}}></div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          )}
                          {item.en_description && (
                            <div className='custom-docs-block'>
                              <div className='col-xl-3 w-30'>
                                <div className='fs-6 fw-bold mt-2 mb-3'>
                                  {t('Custom Docs English Description :')}
                                </div>
                              </div>
                              <div className='col-xl-9'>
                                <div className='d-flex flex-column'>
                                  <div className='fw-semibold text-gray-600 '>
                                    <div
                                      dangerouslySetInnerHTML={{__html: item['en_description']}}
                                    ></div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          )}
                          {item.ru_title && (
                            <div className='custom-docs-block'>
                              <div className='col-xl-3 w-30'>
                                <div className='fs-6 fw-bold mt-2 mb-3'>
                                  {t('Custom Docs Russian Title :')}
                                </div>
                              </div>
                              <div className='col-xl-9'>
                                <div className='d-flex flex-column'>
                                  <div className='fw-semibold text-gray-600 '>
                                    <div dangerouslySetInnerHTML={{__html: item['ru_title']}}></div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          )}
                          {item.ru_description && (
                            <div className='custom-docs-block'>
                              <div className='col-xl-3 w-30'>
                                <div className='fs-6 fw-bold mt-2 mb-3'>
                                  {t('Custom Docs Russian Description :')}
                                </div>
                              </div>
                              <div className='col-xl-9'>
                                <div className='d-flex flex-column'>
                                  <div className='fw-semibold text-gray-600 '>
                                    <div
                                      dangerouslySetInnerHTML={{__html: item['ru_description']}}
                                    ></div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          )}
                          {item.uz_title && (
                            <div className='custom-docs-block'>
                              <div className='col-xl-3 w-30'>
                                <div className='fs-6 fw-bold mt-2 mb-3'>
                                  {t('Custom Docs Uzbek Title :')}
                                </div>
                              </div>
                              <div className='col-xl-9'>
                                <div className='d-flex flex-column'>
                                  <div className='fw-semibold text-gray-600 '>
                                    <div dangerouslySetInnerHTML={{__html: item['uz_title']}}></div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          )}
                          {item.uz_description && (
                            <div className='custom-docs-block'>
                              <div className='col-xl-3 w-30'>
                                <div className='fs-6 fw-bold mt-2 mb-3'>
                                  {t('Custom Docs Uzbek Description :')}
                                </div>
                              </div>
                              <div className='col-xl-9'>
                                <div className='d-flex flex-column'>
                                  <div className='fw-semibold text-gray-600 '>
                                    <div
                                      dangerouslySetInnerHTML={{__html: item['uz_description']}}
                                    ></div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          )}
                        </div>
                      )
                    })}
                </div>

                <div className='col-xl-3 border-bottom border-light border-2 w-100 mb-5 mt-5'>
                  <div className='fs-3 fw-bold mb-5 '>{t('Availability')}</div>
                </div>

                {carRental['deposit'] > 0 && (
                  <div className='row mb-8'>
                    {/* <!--begin::Col--> */}
                    <div className='col-xl-3'>
                      <div className='fs-6 fw-bold mt-2 mb-3'>{t('Security deposit amount')}</div>
                    </div>
                    {/* <!--end::Col--> */}

                    {/* <!--begin::Col--> */}
                    <div className='col-xl-9'>
                      {/* <!--begin::Progress--> */}
                      <div className='d-flex flex-column'>
                        <div className=' fw-semibold text-gray-600 mt-3'>
                          <div
                            dangerouslySetInnerHTML={{
                              __html: carRental['deposit'],
                            }}
                          ></div>
                        </div>
                      </div>
                      {/* <!--end::Progress--> */}
                    </div>
                    {/* <!--end::Col--> */}
                  </div>
                )}

                {carRental['availableDate'] ? (
                  <>
                    {/* <!--begin::Row--> */}
                    <div className='row mb-8'>
                      {/* <!--begin::Col--> */}
                      <div className='col-xl-3'>
                        <div className='fs-6 fw-bold mt-2 mb-3'>{t('Available Date')}</div>
                      </div>
                      {/* <!--end::Col--> */}

                      {/* <!--begin::Col--> */}
                      <div className='col-xl-9'>
                        {/* <!--begin::Progress--> */}
                        <div className='d-flex flex-column'>
                          <div className=' fw-semibold text-gray-600 mt-3'>
                            <div className='d-flex'>
                              <div>
                                {t('From:')}{' '}
                                {isCreatedDateValid
                                  ? createdDate.toLocaleDateString('en-GB', {
                                      day: '2-digit',
                                      month: 'long',
                                      year: 'numeric',
                                    })
                                  : 'Invalid date'}
                              </div>
                              <div className='date-separator'></div>
                              <div>
                                {t('To:')}{' '}
                                {isCreatedDateTwoYearsLaterValid
                                  ? createdDateTwoYearsLater.toLocaleDateString('en-GB', {
                                      day: '2-digit',
                                      month: 'long',
                                      year: 'numeric',
                                    })
                                  : 'Invalid date'}
                              </div>
                            </div>
                          </div>
                        </div>
                        {/* <!--end::Progress--> */}
                      </div>
                      {/* <!--end::Col--> */}
                    </div>
                    {/* <!--end::Row--> */}
                  </>
                ) : (
                  ''
                )}
                {unavailableDates.length > 0 ? (
                  <>
                    {/* <!--begin::Row--> */}
                    <div className='row mb-8'>
                      {/* <!--begin::Col--> */}
                      <div className='col-xl-3'>
                        <div className='fs-6 fw-bold mt-2 mb-3'>{t('Un Available Date')}</div>
                      </div>
                      {/* <!--end::Col--> */}

                      {/* <!--begin::Col--> */}
                      <div className='col-xl-9'>
                        {/* <!--begin::Progress--> */}
                        <div className='d-flex flex-column'>
                          <div className=' fw-semibold text-gray-600 mt-3'>
                            <div className='d-flex'>
                              {unavailableDates.length > 0 && <>{unavailableDates.join(', ')}</>}
                            </div>
                          </div>
                        </div>
                        {/* <!--end::Progress--> */}
                      </div>
                      {/* <!--end::Col--> */}
                    </div>
                    {/* <!--end::Row--> */}
                  </>
                ) : (
                  ''
                )}

                {carRental['en_pickupBranchName'] != '' ? (
                  <div className='col-xl-3 border-bottom border-light border-2 w-100 mb-5 mt-5'>
                    <div className='fs-3 fw-bold mb-5 '>{t('Pick-Up & Drop-Off Information')}</div>
                  </div>
                ) : (
                  ''
                )}
                {carRental['en_pickupBranchName'] && (
                  <div className='row mb-8'>
                    {/* <!--begin::Col--> */}
                    <div className='col-xl-3'>
                      <div className='fs-6 fw-bold mt-2 mb-3'>
                        {t('Pick Up Branch Name English')}
                      </div>
                    </div>
                    {/* <!--end::Col--> */}

                    {/* <!--begin::Col--> */}
                    <div className='col-xl-9'>
                      {/* <!--begin::Progress--> */}
                      <div className='d-flex flex-column'>
                        <div className=' fw-semibold text-gray-600 mt-3'>
                          <div
                            dangerouslySetInnerHTML={{
                              __html: carRental['en_pickupBranchName'],
                            }}
                          ></div>
                        </div>
                      </div>
                      {/* <!--end::Progress--> */}
                    </div>
                    {/* <!--end::Col--> */}
                  </div>
                )}
                {carRental['ru_pickupBranchName'] && (
                  <div className='row mb-8'>
                    {/* <!--begin::Col--> */}
                    <div className='col-xl-3'>
                      <div className='fs-6 fw-bold mt-2 mb-3'>
                        {t('Pick Up Branch Name Russian')}
                      </div>
                    </div>
                    {/* <!--end::Col--> */}

                    {/* <!--begin::Col--> */}
                    <div className='col-xl-9'>
                      {/* <!--begin::Progress--> */}
                      <div className='d-flex flex-column'>
                        <div className=' fw-semibold text-gray-600 mt-3'>
                          <div
                            dangerouslySetInnerHTML={{
                              __html: carRental['ru_pickupBranchName'],
                            }}
                          ></div>
                        </div>
                      </div>
                      {/* <!--end::Progress--> */}
                    </div>
                    {/* <!--end::Col--> */}
                  </div>
                )}
                {carRental['uz_pickupBranchName'] && (
                  <div className='row mb-8'>
                    {/* <!--begin::Col--> */}
                    <div className='col-xl-3'>
                      <div className='fs-6 fw-bold mt-2 mb-3'>{t('Pick Up Branch Name Uzbek')}</div>
                    </div>
                    {/* <!--end::Col--> */}

                    {/* <!--begin::Col--> */}
                    <div className='col-xl-9'>
                      {/* <!--begin::Progress--> */}
                      <div className='d-flex flex-column'>
                        <div className=' fw-semibold text-gray-600 mt-3'>
                          <div
                            dangerouslySetInnerHTML={{
                              __html: carRental['uz_pickupBranchName'],
                            }}
                          ></div>
                        </div>
                      </div>
                      {/* <!--end::Progress--> */}
                    </div>
                    {/* <!--end::Col--> */}
                  </div>
                )}
                {carRental['en_pickupHowGettingThere'] && (
                  <div className='row mb-8'>
                    {/* <!--begin::Col--> */}
                    <div className='col-xl-3'>
                      <div className='fs-6 fw-bold mt-2 mb-3'>
                        {t('How Getting There? (English)')}
                      </div>
                    </div>
                    {/* <!--end::Col--> */}

                    {/* <!--begin::Col--> */}
                    <div className='col-xl-9'>
                      {/* <!--begin::Progress--> */}
                      <div className='d-flex flex-column'>
                        <div className=' fw-semibold text-gray-600 mt-3'>
                          <div
                            dangerouslySetInnerHTML={{
                              __html: carRental['en_pickupHowGettingThere'],
                            }}
                          ></div>
                        </div>
                      </div>
                      {/* <!--end::Progress--> */}
                    </div>
                    {/* <!--end::Col--> */}
                  </div>
                )}
                {carRental['ru_pickupHowGettingThere'] && (
                  <div className='row mb-8'>
                    {/* <!--begin::Col--> */}
                    <div className='col-xl-3'>
                      <div className='fs-6 fw-bold mt-2 mb-3'>
                        {t('How Getting There? (Russian)')}
                      </div>
                    </div>
                    {/* <!--end::Col--> */}

                    {/* <!--begin::Col--> */}
                    <div className='col-xl-9'>
                      {/* <!--begin::Progress--> */}
                      <div className='d-flex flex-column'>
                        <div className=' fw-semibold text-gray-600 mt-3'>
                          <div
                            dangerouslySetInnerHTML={{
                              __html: carRental['ru_pickupHowGettingThere'],
                            }}
                          ></div>
                        </div>
                      </div>
                      {/* <!--end::Progress--> */}
                    </div>
                    {/* <!--end::Col--> */}
                  </div>
                )}
                {carRental['uz_pickupHowGettingThere'] && (
                  <div className='row mb-8'>
                    {/* <!--begin::Col--> */}
                    <div className='col-xl-3'>
                      <div className='fs-6 fw-bold mt-2 mb-3'>
                        {t('How Getting There? (Uzbek)')}
                      </div>
                    </div>
                    {/* <!--end::Col--> */}

                    {/* <!--begin::Col--> */}
                    <div className='col-xl-9'>
                      {/* <!--begin::Progress--> */}
                      <div className='d-flex flex-column'>
                        <div className=' fw-semibold text-gray-600 mt-3'>
                          <div
                            dangerouslySetInnerHTML={{
                              __html: carRental['uz_pickupHowGettingThere'],
                            }}
                          ></div>
                        </div>
                      </div>
                      {/* <!--end::Progress--> */}
                    </div>
                    {/* <!--end::Col--> */}
                  </div>
                )}
                {carRental['en_pickupInstruction'] && (
                  <div className='row mb-8'>
                    {/* <!--begin::Col--> */}
                    <div className='col-xl-3'>
                      <div className='fs-6 fw-bold mt-2 mb-3'>{t('Instruction (English)')}</div>
                    </div>
                    {/* <!--end::Col--> */}

                    {/* <!--begin::Col--> */}
                    <div className='col-xl-9'>
                      {/* <!--begin::Progress--> */}
                      <div className='d-flex flex-column'>
                        <div className=' fw-semibold text-gray-600 mt-3'>
                          <div
                            dangerouslySetInnerHTML={{
                              __html: carRental['en_pickupInstruction'],
                            }}
                          ></div>
                        </div>
                      </div>
                      {/* <!--end::Progress--> */}
                    </div>
                    {/* <!--end::Col--> */}
                  </div>
                )}
                {carRental['ru_pickupInstruction'] && (
                  <div className='row mb-8'>
                    {/* <!--begin::Col--> */}
                    <div className='col-xl-3'>
                      <div className='fs-6 fw-bold mt-2 mb-3'>{t('Instruction (Russian)')}</div>
                    </div>
                    {/* <!--end::Col--> */}

                    {/* <!--begin::Col--> */}
                    <div className='col-xl-9'>
                      {/* <!--begin::Progress--> */}
                      <div className='d-flex flex-column'>
                        <div className=' fw-semibold text-gray-600 mt-3'>
                          <div
                            dangerouslySetInnerHTML={{
                              __html: carRental['ru_pickupInstruction'],
                            }}
                          ></div>
                        </div>
                      </div>
                      {/* <!--end::Progress--> */}
                    </div>
                    {/* <!--end::Col--> */}
                  </div>
                )}
                {carRental['uz_pickupInstruction'] && (
                  <div className='row mb-8'>
                    {/* <!--begin::Col--> */}
                    <div className='col-xl-3'>
                      <div className='fs-6 fw-bold mt-2 mb-3'>{t('Instruction (Uzbek)')}</div>
                    </div>
                    {/* <!--end::Col--> */}

                    {/* <!--begin::Col--> */}
                    <div className='col-xl-9'>
                      {/* <!--begin::Progress--> */}
                      <div className='d-flex flex-column'>
                        <div className=' fw-semibold text-gray-600 mt-3'>
                          <div
                            dangerouslySetInnerHTML={{
                              __html: carRental['uz_pickupInstruction'],
                            }}
                          ></div>
                        </div>
                      </div>
                      {/* <!--end::Progress--> */}
                    </div>
                    {/* <!--end::Col--> */}
                  </div>
                )}
                {carRental['pickupBranchAddress'] && (
                  <div className='row mb-8'>
                    {/* <!--begin::Col--> */}
                    <div className='col-xl-3'>
                      <div className='fs-6 fw-bold mt-2 mb-3'>{t('Pick Up Branch Address')}</div>
                    </div>
                    {/* <!--end::Col--> */}

                    {/* <!--begin::Col--> */}
                    <div className='col-xl-9'>
                      {/* <!--begin::Progress--> */}
                      <div className='d-flex flex-column'>
                        <div className=' fw-semibold text-gray-600 mt-3'>
                          <div
                            dangerouslySetInnerHTML={{
                              __html: carRental['pickupBranchAddress'],
                            }}
                          ></div>
                        </div>
                      </div>
                      {/* <!--end::Progress--> */}
                    </div>
                    {/* <!--end::Col--> */}
                  </div>
                )}
                {carRental['pickupContactNumber'] && (
                  <div className='row mb-8'>
                    {/* <!--begin::Col--> */}
                    <div className='col-xl-3'>
                      <div className='fs-6 fw-bold mt-2 mb-3'>{t('Pick Up Contact Number')}</div>
                    </div>
                    {/* <!--end::Col--> */}

                    {/* <!--begin::Col--> */}
                    <div className='col-xl-9'>
                      {/* <!--begin::Progress--> */}
                      <div className='d-flex flex-column'>
                        <div className=' fw-semibold text-gray-600 mt-3'>
                          <div
                            dangerouslySetInnerHTML={{
                              __html: carRental['pickupContactNumber'],
                            }}
                          ></div>
                        </div>
                      </div>
                      {/* <!--end::Progress--> */}
                    </div>
                    {/* <!--end::Col--> */}
                  </div>
                )}

                {carRental['pickupOpeningHour'] && carRental['pickupOpeningHour'].length > 0 && (
                  <>
                    {/* <!--begin::Row--> */}
                    <div className='row mb-8'>
                      {/* <!--begin::Col--> */}
                      <div className='col-xl-3'>
                        <div className='fs-6 fw-bold mt-2 mb-3'>{t('Pick Up Opening Hours')}</div>
                      </div>
                      {/* <!--end::Col--> */}

                      {/* <!--begin::Col--> */}
                      <div className='col-xl-9'>
                        {/* <!--begin::Progress--> */}
                        <div className='d-flex flex-column'>
                          {carRental['pickupOpeningHour'].map((dayInfo: any, index: any) => (
                            <div className='fw-semibold text-gray-600 mt-3' key={index}>
                              <div>
                                <strong>{t('Day')}:</strong> {dayInfo.day}
                              </div>
                              {dayInfo.timeSlot.map((slot: any, slotIndex: any) => (
                                <div key={slotIndex}>
                                  <strong>Time Slot {slotIndex + 1}:</strong>{' '}
                                  {formatTime(slot.startTime)} - {formatTime(slot.endTime)}
                                </div>
                              ))}
                            </div>
                          ))}
                        </div>
                        {/* <!--end::Progress--> */}
                      </div>
                      {/* <!--end::Col--> */}
                    </div>
                    {/* <!--end::Row--> */}
                  </>
                )}
                {carRental['en_dropoffBranchName'] && (
                  <div className='row mb-8'>
                    {/* <!--begin::Col--> */}
                    <div className='col-xl-3'>
                      <div className='fs-6 fw-bold mt-2 mb-3'>
                        {t('Drop Off Branch Name English')}
                      </div>
                    </div>
                    {/* <!--end::Col--> */}

                    {/* <!--begin::Col--> */}
                    <div className='col-xl-9'>
                      {/* <!--begin::Progress--> */}
                      <div className='d-flex flex-column'>
                        <div className=' fw-semibold text-gray-600 mt-3'>
                          <div
                            dangerouslySetInnerHTML={{
                              __html: carRental['en_dropoffBranchName'],
                            }}
                          ></div>
                        </div>
                      </div>
                      {/* <!--end::Progress--> */}
                    </div>
                    {/* <!--end::Col--> */}
                  </div>
                )}
                {carRental['ru_dropoffBranchName'] && (
                  <div className='row mb-8'>
                    {/* <!--begin::Col--> */}
                    <div className='col-xl-3'>
                      <div className='fs-6 fw-bold mt-2 mb-3'>
                        {t('Drop Off Branch Name Russian')}
                      </div>
                    </div>
                    {/* <!--end::Col--> */}

                    {/* <!--begin::Col--> */}
                    <div className='col-xl-9'>
                      {/* <!--begin::Progress--> */}
                      <div className='d-flex flex-column'>
                        <div className=' fw-semibold text-gray-600 mt-3'>
                          <div
                            dangerouslySetInnerHTML={{
                              __html: carRental['ru_dropoffBranchName'],
                            }}
                          ></div>
                        </div>
                      </div>
                      {/* <!--end::Progress--> */}
                    </div>
                    {/* <!--end::Col--> */}
                  </div>
                )}
                {carRental['uz_dropoffBranchName'] && (
                  <div className='row mb-8'>
                    {/* <!--begin::Col--> */}
                    <div className='col-xl-3'>
                      <div className='fs-6 fw-bold mt-2 mb-3'>
                        {t('Drop Off Branch Name Uzbek')}
                      </div>
                    </div>
                    {/* <!--end::Col--> */}

                    {/* <!--begin::Col--> */}
                    <div className='col-xl-9'>
                      {/* <!--begin::Progress--> */}
                      <div className='d-flex flex-column'>
                        <div className=' fw-semibold text-gray-600 mt-3'>
                          <div
                            dangerouslySetInnerHTML={{
                              __html: carRental['uz_dropoffBranchName'],
                            }}
                          ></div>
                        </div>
                      </div>
                      {/* <!--end::Progress--> */}
                    </div>
                    {/* <!--end::Col--> */}
                  </div>
                )}
                {carRental['en_dropoffHowGettingThere'] && (
                  <div className='row mb-8'>
                    {/* <!--begin::Col--> */}
                    <div className='col-xl-3'>
                      <div className='fs-6 fw-bold mt-2 mb-3'>
                        {t('How Getting There? (English)')}
                      </div>
                    </div>
                    {/* <!--end::Col--> */}

                    {/* <!--begin::Col--> */}
                    <div className='col-xl-9'>
                      {/* <!--begin::Progress--> */}
                      <div className='d-flex flex-column'>
                        <div className=' fw-semibold text-gray-600 mt-3'>
                          <div
                            dangerouslySetInnerHTML={{
                              __html: carRental['en_dropoffHowGettingThere'],
                            }}
                          ></div>
                        </div>
                      </div>
                      {/* <!--end::Progress--> */}
                    </div>
                    {/* <!--end::Col--> */}
                  </div>
                )}
                {carRental['ru_dropoffHowGettingThere'] && (
                  <div className='row mb-8'>
                    {/* <!--begin::Col--> */}
                    <div className='col-xl-3'>
                      <div className='fs-6 fw-bold mt-2 mb-3'>
                        {t('How Getting There? (Russian)')}
                      </div>
                    </div>
                    {/* <!--end::Col--> */}

                    {/* <!--begin::Col--> */}
                    <div className='col-xl-9'>
                      {/* <!--begin::Progress--> */}
                      <div className='d-flex flex-column'>
                        <div className=' fw-semibold text-gray-600 mt-3'>
                          <div
                            dangerouslySetInnerHTML={{
                              __html: carRental['ru_dropoffHowGettingThere'],
                            }}
                          ></div>
                        </div>
                      </div>
                      {/* <!--end::Progress--> */}
                    </div>
                    {/* <!--end::Col--> */}
                  </div>
                )}
                {carRental['uz_dropoffHowGettingThere'] && (
                  <div className='row mb-8'>
                    {/* <!--begin::Col--> */}
                    <div className='col-xl-3'>
                      <div className='fs-6 fw-bold mt-2 mb-3'>
                        {t('How Getting There? (Uzbek)')}
                      </div>
                    </div>
                    {/* <!--end::Col--> */}

                    {/* <!--begin::Col--> */}
                    <div className='col-xl-9'>
                      {/* <!--begin::Progress--> */}
                      <div className='d-flex flex-column'>
                        <div className=' fw-semibold text-gray-600 mt-3'>
                          <div
                            dangerouslySetInnerHTML={{
                              __html: carRental['uz_dropoffHowGettingThere'],
                            }}
                          ></div>
                        </div>
                      </div>
                      {/* <!--end::Progress--> */}
                    </div>
                    {/* <!--end::Col--> */}
                  </div>
                )}
                {carRental['en_dropoffInstruction'] && (
                  <div className='row mb-8'>
                    {/* <!--begin::Col--> */}
                    <div className='col-xl-3'>
                      <div className='fs-6 fw-bold mt-2 mb-3'>{t('Instruction (English)')}</div>
                    </div>
                    {/* <!--end::Col--> */}

                    {/* <!--begin::Col--> */}
                    <div className='col-xl-9'>
                      {/* <!--begin::Progress--> */}
                      <div className='d-flex flex-column'>
                        <div className=' fw-semibold text-gray-600 mt-3'>
                          <div
                            dangerouslySetInnerHTML={{
                              __html: carRental['en_dropoffInstruction'],
                            }}
                          ></div>
                        </div>
                      </div>
                      {/* <!--end::Progress--> */}
                    </div>
                    {/* <!--end::Col--> */}
                  </div>
                )}
                {carRental['ru_dropoffInstruction'] && (
                  <div className='row mb-8'>
                    {/* <!--begin::Col--> */}
                    <div className='col-xl-3'>
                      <div className='fs-6 fw-bold mt-2 mb-3'>{t('Instruction (Russian)')}</div>
                    </div>
                    {/* <!--end::Col--> */}

                    {/* <!--begin::Col--> */}
                    <div className='col-xl-9'>
                      {/* <!--begin::Progress--> */}
                      <div className='d-flex flex-column'>
                        <div className=' fw-semibold text-gray-600 mt-3'>
                          <div
                            dangerouslySetInnerHTML={{
                              __html: carRental['ru_dropoffInstruction'],
                            }}
                          ></div>
                        </div>
                      </div>
                      {/* <!--end::Progress--> */}
                    </div>
                    {/* <!--end::Col--> */}
                  </div>
                )}
                {carRental['uz_dropoffInstruction'] && (
                  <div className='row mb-8'>
                    {/* <!--begin::Col--> */}
                    <div className='col-xl-3'>
                      <div className='fs-6 fw-bold mt-2 mb-3'>{t('Instruction (Uzbek)')}</div>
                    </div>
                    {/* <!--end::Col--> */}

                    {/* <!--begin::Col--> */}
                    <div className='col-xl-9'>
                      {/* <!--begin::Progress--> */}
                      <div className='d-flex flex-column'>
                        <div className=' fw-semibold text-gray-600 mt-3'>
                          <div
                            dangerouslySetInnerHTML={{
                              __html: carRental['uz_dropoffInstruction'],
                            }}
                          ></div>
                        </div>
                      </div>
                      {/* <!--end::Progress--> */}
                    </div>
                    {/* <!--end::Col--> */}
                  </div>
                )}
                {carRental['dropoffBranchAddress'] && (
                  <div className='row mb-8'>
                    {/* <!--begin::Col--> */}
                    <div className='col-xl-3'>
                      <div className='fs-6 fw-bold mt-2 mb-3'>{t('Drop Off Branch Address')}</div>
                    </div>
                    {/* <!--end::Col--> */}

                    {/* <!--begin::Col--> */}
                    <div className='col-xl-9'>
                      {/* <!--begin::Progress--> */}
                      <div className='d-flex flex-column'>
                        <div className=' fw-semibold text-gray-600 mt-3'>
                          <div
                            dangerouslySetInnerHTML={{
                              __html: carRental['dropoffBranchAddress'],
                            }}
                          ></div>
                        </div>
                      </div>
                      {/* <!--end::Progress--> */}
                    </div>
                    {/* <!--end::Col--> */}
                  </div>
                )}
                {carRental['dropoffContactNumber'] && (
                  <div className='row mb-8'>
                    {/* <!--begin::Col--> */}
                    <div className='col-xl-3'>
                      <div className='fs-6 fw-bold mt-2 mb-3'>{t('Drop Off Contact Number')}</div>
                    </div>
                    {/* <!--end::Col--> */}

                    {/* <!--begin::Col--> */}
                    <div className='col-xl-9'>
                      {/* <!--begin::Progress--> */}
                      <div className='d-flex flex-column'>
                        <div className=' fw-semibold text-gray-600 mt-3'>
                          <div
                            dangerouslySetInnerHTML={{
                              __html: carRental['dropoffContactNumber'],
                            }}
                          ></div>
                        </div>
                      </div>
                      {/* <!--end::Progress--> */}
                    </div>
                    {/* <!--end::Col--> */}
                  </div>
                )}

                {carRental['dropoffOpeningHour'] && carRental['dropoffOpeningHour'].length > 0 && (
                  <>
                    {/* <!--begin::Row--> */}
                    <div className='row mb-8'>
                      {/* <!--begin::Col--> */}
                      <div className='col-xl-3'>
                        <div className='fs-6 fw-bold mt-2 mb-3'>{t('Drop Off Opening Hours')}</div>
                      </div>
                      {/* <!--end::Col--> */}

                      {/* <!--begin::Col--> */}
                      <div className='col-xl-9'>
                        {/* <!--begin::Progress--> */}
                        <div className='d-flex flex-column'>
                          {carRental['dropoffOpeningHour'].map((dayInfo: any, index: any) => (
                            <div className='fw-semibold text-gray-600 mt-3' key={index}>
                              <div>
                                <strong>{t('Day')}:</strong> {dayInfo.day}
                              </div>
                              {dayInfo.timeSlot.map((slot: any, slotIndex: any) => (
                                <div key={slotIndex}>
                                  <strong>Time Slot {slotIndex + 1}:</strong>{' '}
                                  {formatTime(slot.startTime)} - {formatTime(slot.endTime)}
                                </div>
                              ))}
                            </div>
                          ))}
                        </div>
                        {/* <!--end::Progress--> */}
                      </div>
                      {/* <!--end::Col--> */}
                    </div>
                    {/* <!--end::Row--> */}
                  </>
                )}
                {/* <!--begin::Row--> */}

                {carRental['policyDetail']['en_mileagePolicy'] != '' &&
                carRental['policyDetail']['en_mileagePolicy'] != undefined &&
                carRental['policyDetail']['en_mileagePolicy'] != null ? (
                  <div className='col-xl-3 border-bottom border-light border-2 w-100 mb-5 mt-5'>
                    <div className='fs-3 fw-bold mb-5 '>{t('Car Policies')}</div>
                  </div>
                ) : (
                  ''
                )}

               <div className='card card-custom my-5'>
                                    <div className='card-header card-header-stretch overflow-auto'>
                                        <ul
                                            className='nav nav-stretch nav-line-tabs fw-semibold border-transparent flex-nowrap'
                                            role='tablist'
                                        >
                                            <li className='nav-item'>
                                                <a
                                                    className={clsx(`nav-link cursor-pointer text-uppercase text-center`, { active: tab === '1' })}
                                                    onClick={() => setTab('1')}
                                                    role='tab'
                                                >
                                                    {t('About Fees & Charges')}
                                                </a>
                                            </li>
                                            <li className='nav-item'>
                                                <a
                                                    className={clsx(`nav-link cursor-pointer text-uppercase text-center`, { active: tab === '2' })}
                                                    onClick={() => setTab('2')}
                                                    role='tab'
                                                >
                                                    {t('Early/Late Pick Up & Drop Off')}
                                                </a>
                                            </li>
                                            <li className='nav-item'>
                                                <a
                                                    className={clsx(`nav-link cursor-pointer text-uppercase text-center`, { active: tab === '3' })}
                                                    onClick={() => setTab('3')}
                                                    role='tab'
                                                >
                                                    {t('Pick Up Information')}
                                                </a>
                                            </li>
                                            <li className='nav-item'>
                                                <a
                                                    className={clsx(`nav-link cursor-pointer text-uppercase text-center`, { active: tab === '4' })}
                                                    onClick={() => setTab('4')}
                                                    role='tab'
                                                >
                                                    {t('Extras')}
                                                </a>
                                            </li>
                                            <li className='nav-item'>
                                                <a
                                                    className={clsx(`nav-link cursor-pointer text-uppercase text-center`, { active: tab === '5' })}
                                                    onClick={() => setTab('5')}
                                                    role='tab'
                                                >
                                                    {t('Cancellation')}
                                                </a>
                                            </li>
                                            <li className='nav-item'>
                                                <a
                                                    className={clsx(`nav-link cursor-pointer text-uppercase text-center`, { active: tab === '6' })}
                                                    onClick={() => setTab('6')}
                                                    role='tab'
                                                >
                                                    {t('Information About The Car Supplier')}
                                                </a>
                                            </li>
                                            <li className='nav-item'>
                                                <a
                                                    className={clsx(`nav-link cursor-pointer text-uppercase text-center`, { active: tab === '7' })}
                                                    onClick={() => setTab('7')}
                                                    role='tab'
                                                >
                                                    {t('Custom Policy Add')}
                                                </a>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                                <div className="card-body">
                                    <div className='tab-content'>
                                        <div className={clsx('tab-pane', { active: tab === '1' })}>
                                            {carRental['policyDetail']['en_mileagePolicy'] && (
                                                <>
                                                    {/* <!--begin::Row--> */}
                                                    <div className='row mb-8'>
                                                        {/* <!--begin::Col--> */}
                                                        <div className='col-xl-3'>
                                                            <div className='fs-6 fw-bold mt-2 mb-3'>{t('Mileage Policy (English)')}</div>
                                                        </div>
                                                        {/* <!--end::Col--> */}

                                                        {/* <!--begin::Col--> */}
                                                        <div className='col-xl-9'>
                                                            {/* <!--begin::Progress--> */}
                                                            <div className='d-flex flex-column'>
                                                                <div className=' fw-semibold text-gray-600 mt-3'>
                                                                    <div
                                                                        dangerouslySetInnerHTML={{
                                                                            __html: carRental['policyDetail']['en_mileagePolicy'],
                                                                        }}
                                                                    ></div>
                                                                </div>
                                                            </div>
                                                            {/* <!--end::Progress--> */}
                                                        </div>
                                                        {/* <!--end::Col--> */}
                                                    </div>
                                                    {/* <!--end::Row--> */}
                                                </>
                                            )}
                                            {carRental['policyDetail']['ru_mileagePolicy'] && (
                                                <>
                                                    {/* <!--begin::Row--> */}
                                                    <div className='row mb-8'>
                                                        {/* <!--begin::Col--> */}
                                                        <div className='col-xl-3'>
                                                            <div className='fs-6 fw-bold mt-2 mb-3'>{t('Mileage Policy (Russian)')}</div>
                                                        </div>
                                                        {/* <!--end::Col--> */}

                                                        {/* <!--begin::Col--> */}
                                                        <div className='col-xl-9'>
                                                            {/* <!--begin::Progress--> */}
                                                            <div className='d-flex flex-column'>
                                                                <div className=' fw-semibold text-gray-600 mt-3'>
                                                                    <div
                                                                        dangerouslySetInnerHTML={{
                                                                            __html: carRental['policyDetail']['ru_mileagePolicy'],
                                                                        }}
                                                                    ></div>
                                                                </div>
                                                            </div>
                                                            {/* <!--end::Progress--> */}
                                                        </div>
                                                        {/* <!--end::Col--> */}
                                                    </div>
                                                    {/* <!--end::Row--> */}
                                                </>
                                            )}
                                            {carRental['policyDetail']['uz_mileagePolicy'] && (
                                                <>
                                                    {/* <!--begin::Row--> */}
                                                    <div className='row mb-8'>
                                                        {/* <!--begin::Col--> */}
                                                        <div className='col-xl-3'>
                                                            <div className='fs-6 fw-bold mt-2 mb-3'>{t('Mileage Policy (Uzbek)')}</div>
                                                        </div>
                                                        {/* <!--end::Col--> */}

                                                        {/* <!--begin::Col--> */}
                                                        <div className='col-xl-9'>
                                                            {/* <!--begin::Progress--> */}
                                                            <div className='d-flex flex-column'>
                                                                <div className=' fw-semibold text-gray-600 mt-3'>
                                                                    <div
                                                                        dangerouslySetInnerHTML={{
                                                                            __html: carRental['policyDetail']['uz_mileagePolicy'],
                                                                        }}
                                                                    ></div>
                                                                </div>
                                                            </div>
                                                            {/* <!--end::Progress--> */}
                                                        </div>
                                                        {/* <!--end::Col--> */}
                                                    </div>
                                                    {/* <!--end::Row--> */}
                                                </>
                                            )}
                                            {carRental['policyDetail']['en_fuelPolicy'] && (
                                                <>
                                                    {/* <!--begin::Row--> */}
                                                    <div className='row mb-8'>
                                                        {/* <!--begin::Col--> */}
                                                        <div className='col-xl-3'>
                                                            <div className='fs-6 fw-bold mt-2 mb-3'>{t('Fuel Policy (English)')}</div>
                                                        </div>
                                                        {/* <!--end::Col--> */}

                                                        {/* <!--begin::Col--> */}
                                                        <div className='col-xl-9'>
                                                            {/* <!--begin::Progress--> */}
                                                            <div className='d-flex flex-column'>
                                                                <div className=' fw-semibold text-gray-600 mt-3'>
                                                                    <div
                                                                        dangerouslySetInnerHTML={{
                                                                            __html: carRental['policyDetail']['en_fuelPolicy'],
                                                                        }}
                                                                    ></div>
                                                                </div>
                                                            </div>
                                                            {/* <!--end::Progress--> */}
                                                        </div>
                                                        {/* <!--end::Col--> */}
                                                    </div>
                                                    {/* <!--end::Row--> */}
                                                </>
                                            )}
                                            {carRental['policyDetail']['ru_fuelPolicy'] && (
                                                <>
                                                    {/* <!--begin::Row--> */}
                                                    <div className='row mb-8'>
                                                        {/* <!--begin::Col--> */}
                                                        <div className='col-xl-3'>
                                                            <div className='fs-6 fw-bold mt-2 mb-3'>{t('Fuel Policy (Russian)')}</div>
                                                        </div>
                                                        {/* <!--end::Col--> */}

                                                        {/* <!--begin::Col--> */}
                                                        <div className='col-xl-9'>
                                                            {/* <!--begin::Progress--> */}
                                                            <div className='d-flex flex-column'>
                                                                <div className=' fw-semibold text-gray-600 mt-3'>
                                                                    <div
                                                                        dangerouslySetInnerHTML={{
                                                                            __html: carRental['policyDetail']['ru_fuelPolicy'],
                                                                        }}
                                                                    ></div>
                                                                </div>
                                                            </div>
                                                            {/* <!--end::Progress--> */}
                                                        </div>
                                                        {/* <!--end::Col--> */}
                                                    </div>
                                                    {/* <!--end::Row--> */}
                                                </>
                                            )}
                                            {carRental['policyDetail']['uz_fuelPolicy'] && (
                                                <>
                                                    {/* <!--begin::Row--> */}
                                                    <div className='row mb-8'>
                                                        {/* <!--begin::Col--> */}
                                                        <div className='col-xl-3'>
                                                            <div className='fs-6 fw-bold mt-2 mb-3'>{t('Fuel Policy (Uzbek)')}</div>
                                                        </div>
                                                        {/* <!--end::Col--> */}

                                                        {/* <!--begin::Col--> */}
                                                        <div className='col-xl-9'>
                                                            {/* <!--begin::Progress--> */}
                                                            <div className='d-flex flex-column'>
                                                                <div className=' fw-semibold text-gray-600 mt-3'>
                                                                    <div
                                                                        dangerouslySetInnerHTML={{
                                                                            __html: carRental['policyDetail']['uz_fuelPolicy'],
                                                                        }}
                                                                    ></div>
                                                                </div>
                                                            </div>
                                                            {/* <!--end::Progress--> */}
                                                        </div>
                                                        {/* <!--end::Col--> */}
                                                    </div>
                                                    {/* <!--end::Row--> */}
                                                </>
                                            )}
                                            {carRental['policyDetail']['en_ageRequirement'] && (
                                                <>
                                                    {/* <!--begin::Row--> */}
                                                    <div className='row mb-8'>
                                                        {/* <!--begin::Col--> */}
                                                        <div className='col-xl-3'>
                                                            <div className='fs-6 fw-bold mt-2 mb-3'>{t('Age Requirement (English)')}</div>
                                                        </div>
                                                        {/* <!--end::Col--> */}

                                                        {/* <!--begin::Col--> */}
                                                        <div className='col-xl-9'>
                                                            {/* <!--begin::Progress--> */}
                                                            <div className='d-flex flex-column'>
                                                                <div className=' fw-semibold text-gray-600 mt-3'>
                                                                    <div
                                                                        dangerouslySetInnerHTML={{
                                                                            __html: carRental['policyDetail']['en_ageRequirement'],
                                                                        }}
                                                                    ></div>
                                                                </div>
                                                            </div>
                                                            {/* <!--end::Progress--> */}
                                                        </div>
                                                        {/* <!--end::Col--> */}
                                                    </div>
                                                    {/* <!--end::Row--> */}
                                                </>
                                            )}
                                            {carRental['policyDetail']['ru_ageRequirement'] && (
                                                <>
                                                    {/* <!--begin::Row--> */}
                                                    <div className='row mb-8'>
                                                        {/* <!--begin::Col--> */}
                                                        <div className='col-xl-3'>
                                                            <div className='fs-6 fw-bold mt-2 mb-3'>{t('Age Requirement (Russian)')}</div>
                                                        </div>
                                                        {/* <!--end::Col--> */}

                                                        {/* <!--begin::Col--> */}
                                                        <div className='col-xl-9'>
                                                            {/* <!--begin::Progress--> */}
                                                            <div className='d-flex flex-column'>
                                                                <div className=' fw-semibold text-gray-600 mt-3'>
                                                                    <div
                                                                        dangerouslySetInnerHTML={{
                                                                            __html: carRental['policyDetail']['ru_ageRequirement'],
                                                                        }}
                                                                    ></div>
                                                                </div>
                                                            </div>
                                                            {/* <!--end::Progress--> */}
                                                        </div>
                                                        {/* <!--end::Col--> */}
                                                    </div>
                                                    {/* <!--end::Row--> */}
                                                </>
                                            )}
                                            {carRental['policyDetail']['uz_ageRequirement'] && (
                                                <>
                                                    {/* <!--begin::Row--> */}
                                                    <div className='row mb-8'>
                                                        {/* <!--begin::Col--> */}
                                                        <div className='col-xl-3'>
                                                            <div className='fs-6 fw-bold mt-2 mb-3'>{t('Age Requirement (Uzbek)')}</div>
                                                        </div>
                                                        {/* <!--end::Col--> */}

                                                        {/* <!--begin::Col--> */}
                                                        <div className='col-xl-9'>
                                                            {/* <!--begin::Progress--> */}
                                                            <div className='d-flex flex-column'>
                                                                <div className=' fw-semibold text-gray-600 mt-3'>
                                                                    <div
                                                                        dangerouslySetInnerHTML={{
                                                                            __html: carRental['policyDetail']['uz_ageRequirement'],
                                                                        }}
                                                                    ></div>
                                                                </div>
                                                            </div>
                                                            {/* <!--end::Progress--> */}
                                                        </div>
                                                        {/* <!--end::Col--> */}
                                                    </div>
                                                    {/* <!--end::Row--> */}
                                                </>
                                            )}
                                            {carRental['policyDetail']['en_additionalDrivers'] && (
                                                <>
                                                    {/* <!--begin::Row--> */}
                                                    <div className='row mb-8'>
                                                        {/* <!--begin::Col--> */}
                                                        <div className='col-xl-3'>
                                                            <div className='fs-6 fw-bold mt-2 mb-3'>{t('Additional Drivers (English)')}</div>
                                                        </div>
                                                        {/* <!--end::Col--> */}

                                                        {/* <!--begin::Col--> */}
                                                        <div className='col-xl-9'>
                                                            {/* <!--begin::Progress--> */}
                                                            <div className='d-flex flex-column'>
                                                                <div className=' fw-semibold text-gray-600 mt-3'>
                                                                    <div
                                                                        dangerouslySetInnerHTML={{
                                                                            __html: carRental['policyDetail']['en_additionalDrivers'],
                                                                        }}
                                                                    ></div>
                                                                </div>
                                                            </div>
                                                            {/* <!--end::Progress--> */}
                                                        </div>
                                                        {/* <!--end::Col--> */}
                                                    </div>
                                                    {/* <!--end::Row--> */}
                                                </>
                                            )}
                                            {carRental['policyDetail']['ru_additionalDrivers'] && (
                                                <>
                                                    {/* <!--begin::Row--> */}
                                                    <div className='row mb-8'>
                                                        {/* <!--begin::Col--> */}
                                                        <div className='col-xl-3'>
                                                            <div className='fs-6 fw-bold mt-2 mb-3'>{t('Additional Drivers (Russian)')}</div>
                                                        </div>
                                                        {/* <!--end::Col--> */}

                                                        {/* <!--begin::Col--> */}
                                                        <div className='col-xl-9'>
                                                            {/* <!--begin::Progress--> */}
                                                            <div className='d-flex flex-column'>
                                                                <div className=' fw-semibold text-gray-600 mt-3'>
                                                                    <div
                                                                        dangerouslySetInnerHTML={{
                                                                            __html: carRental['policyDetail']['ru_additionalDrivers'],
                                                                        }}
                                                                    ></div>
                                                                </div>
                                                            </div>
                                                            {/* <!--end::Progress--> */}
                                                        </div>
                                                        {/* <!--end::Col--> */}
                                                    </div>
                                                    {/* <!--end::Row--> */}
                                                </>
                                            )}
                                            {carRental['policyDetail']['uz_additionalDrivers'] && (
                                                <>
                                                    {/* <!--begin::Row--> */}
                                                    <div className='row mb-8'>
                                                        {/* <!--begin::Col--> */}
                                                        <div className='col-xl-3'>
                                                            <div className='fs-6 fw-bold mt-2 mb-3'>{t('Additional Drivers (Uzbek)')}</div>
                                                        </div>
                                                        {/* <!--end::Col--> */}

                                                        {/* <!--begin::Col--> */}
                                                        <div className='col-xl-9'>
                                                            {/* <!--begin::Progress--> */}
                                                            <div className='d-flex flex-column'>
                                                                <div className=' fw-semibold text-gray-600 mt-3'>
                                                                    <div
                                                                        dangerouslySetInnerHTML={{
                                                                            __html: carRental['policyDetail']['uz_additionalDrivers'],
                                                                        }}
                                                                    ></div>
                                                                </div>
                                                            </div>
                                                            {/* <!--end::Progress--> */}
                                                        </div>
                                                        {/* <!--end::Col--> */}
                                                    </div>
                                                    {/* <!--end::Row--> */}
                                                </>
                                            )}
                                            {carRental['policyDetail']['en_outisideBusinessHour'] && (
                                                <>
                                                    {/* <!--begin::Row--> */}
                                                    <div className='row mb-8'>
                                                        {/* <!--begin::Col--> */}
                                                        <div className='col-xl-3'>
                                                            <div className='fs-6 fw-bold mt-2 mb-3'>
                                                                {t('Out side Business Hour (English)')}
                                                            </div>
                                                        </div>
                                                        {/* <!--end::Col--> */}

                                                        {/* <!--begin::Col--> */}
                                                        <div className='col-xl-9'>
                                                            {/* <!--begin::Progress--> */}
                                                            <div className='d-flex flex-column'>
                                                                <div className=' fw-semibold text-gray-600 mt-3'>
                                                                    <div
                                                                        dangerouslySetInnerHTML={{
                                                                            __html: carRental['policyDetail']['en_outisideBusinessHour'],
                                                                        }}
                                                                    ></div>
                                                                </div>
                                                            </div>
                                                            {/* <!--end::Progress--> */}
                                                        </div>
                                                        {/* <!--end::Col--> */}
                                                    </div>
                                                    {/* <!--end::Row--> */}
                                                </>
                                            )}
                                            {carRental['policyDetail']['ru_outisideBusinessHour'] && (
                                                <>
                                                    {/* <!--begin::Row--> */}
                                                    <div className='row mb-8'>
                                                        {/* <!--begin::Col--> */}
                                                        <div className='col-xl-3'>
                                                            <div className='fs-6 fw-bold mt-2 mb-3'>
                                                                {t('Out side Business Hour (Russian)')}
                                                            </div>
                                                        </div>
                                                        {/* <!--end::Col--> */}

                                                        {/* <!--begin::Col--> */}
                                                        <div className='col-xl-9'>
                                                            {/* <!--begin::Progress--> */}
                                                            <div className='d-flex flex-column'>
                                                                <div className=' fw-semibold text-gray-600 mt-3'>
                                                                    <div
                                                                        dangerouslySetInnerHTML={{
                                                                            __html: carRental['policyDetail']['ru_outisideBusinessHour'],
                                                                        }}
                                                                    ></div>
                                                                </div>
                                                            </div>
                                                            {/* <!--end::Progress--> */}
                                                        </div>
                                                        {/* <!--end::Col--> */}
                                                    </div>
                                                    {/* <!--end::Row--> */}
                                                </>
                                            )}
                                            {carRental['policyDetail']['uz_outisideBusinessHour'] && (
                                                <>
                                                    {/* <!--begin::Row--> */}
                                                    <div className='row mb-8'>
                                                        {/* <!--begin::Col--> */}
                                                        <div className='col-xl-3'>
                                                            <div className='fs-6 fw-bold mt-2 mb-3'>{t('Out side Business Hour (Uzbek)')}</div>
                                                        </div>
                                                        {/* <!--end::Col--> */}

                                                        {/* <!--begin::Col--> */}
                                                        <div className='col-xl-9'>
                                                            {/* <!--begin::Progress--> */}
                                                            <div className='d-flex flex-column'>
                                                                <div className=' fw-semibold text-gray-600 mt-3'>
                                                                    <div
                                                                        dangerouslySetInnerHTML={{
                                                                            __html: carRental['policyDetail']['uz_outisideBusinessHour'],
                                                                        }}
                                                                    ></div>
                                                                </div>
                                                            </div>
                                                            {/* <!--end::Progress--> */}
                                                        </div>
                                                        {/* <!--end::Col--> */}
                                                    </div>
                                                    {/* <!--end::Row--> */}
                                                </>
                                            )}
                                            {carRental['policyDetail']['en_localFees'] && (
                                                <>
                                                    {/* <!--begin::Row--> */}
                                                    <div className='row mb-8'>
                                                        {/* <!--begin::Col--> */}
                                                        <div className='col-xl-3'>
                                                            <div className='fs-6 fw-bold mt-2 mb-3'>{t('Local Fees (English)')}</div>
                                                        </div>
                                                        {/* <!--end::Col--> */}

                                                        {/* <!--begin::Col--> */}
                                                        <div className='col-xl-9'>
                                                            {/* <!--begin::Progress--> */}
                                                            <div className='d-flex flex-column'>
                                                                <div className=' fw-semibold text-gray-600 mt-3'>
                                                                    <div
                                                                        dangerouslySetInnerHTML={{
                                                                            __html: carRental['policyDetail']['en_localFees'],
                                                                        }}
                                                                    ></div>
                                                                </div>
                                                            </div>
                                                            {/* <!--end::Progress--> */}
                                                        </div>
                                                        {/* <!--end::Col--> */}
                                                    </div>
                                                    {/* <!--end::Row--> */}
                                                </>
                                            )}
                                            {carRental['policyDetail']['ru_localFees'] && (
                                                <>
                                                    {/* <!--begin::Row--> */}
                                                    <div className='row mb-8'>
                                                        {/* <!--begin::Col--> */}
                                                        <div className='col-xl-3'>
                                                            <div className='fs-6 fw-bold mt-2 mb-3'>{t('Local Fees (Russian)')}</div>
                                                        </div>
                                                        {/* <!--end::Col--> */}

                                                        {/* <!--begin::Col--> */}
                                                        <div className='col-xl-9'>
                                                            {/* <!--begin::Progress--> */}
                                                            <div className='d-flex flex-column'>
                                                                <div className=' fw-semibold text-gray-600 mt-3'>
                                                                    <div
                                                                        dangerouslySetInnerHTML={{
                                                                            __html: carRental['policyDetail']['ru_localFees'],
                                                                        }}
                                                                    ></div>
                                                                </div>
                                                            </div>
                                                            {/* <!--end::Progress--> */}
                                                        </div>
                                                        {/* <!--end::Col--> */}
                                                    </div>
                                                    {/* <!--end::Row--> */}
                                                </>
                                            )}
                                            {carRental['policyDetail']['uz_localFees'] && (
                                                <>
                                                    {/* <!--begin::Row--> */}
                                                    <div className='row mb-8'>
                                                        {/* <!--begin::Col--> */}
                                                        <div className='col-xl-3'>
                                                            <div className='fs-6 fw-bold mt-2 mb-3'>{t('Local Fees (Uzbek)')}</div>
                                                        </div>
                                                        {/* <!--end::Col--> */}

                                                        {/* <!--begin::Col--> */}
                                                        <div className='col-xl-9'>
                                                            {/* <!--begin::Progress--> */}
                                                            <div className='d-flex flex-column'>
                                                                <div className=' fw-semibold text-gray-600 mt-3'>
                                                                    <div
                                                                        dangerouslySetInnerHTML={{
                                                                            __html: carRental['policyDetail']['uz_localFees'],
                                                                        }}
                                                                    ></div>
                                                                </div>
                                                            </div>
                                                            {/* <!--end::Progress--> */}
                                                        </div>
                                                        {/* <!--end::Col--> */}
                                                    </div>
                                                    {/* <!--end::Row--> */}
                                                </>
                                            )}
                                            {carRental['policyDetail']['en_branchNotice'] && (
                                                <>
                                                    {/* <!--begin::Row--> */}
                                                    <div className='row mb-8'>
                                                        {/* <!--begin::Col--> */}
                                                        <div className='col-xl-3'>
                                                            <div className='fs-6 fw-bold mt-2 mb-3'>{t('Branch Notice (English)')}</div>
                                                        </div>
                                                        {/* <!--end::Col--> */}

                                                        {/* <!--begin::Col--> */}
                                                        <div className='col-xl-9'>
                                                            {/* <!--begin::Progress--> */}
                                                            <div className='d-flex flex-column'>
                                                                <div className=' fw-semibold text-gray-600 mt-3'>
                                                                    <div
                                                                        dangerouslySetInnerHTML={{
                                                                            __html: carRental['policyDetail']['en_branchNotice'],
                                                                        }}
                                                                    ></div>
                                                                </div>
                                                            </div>
                                                            {/* <!--end::Progress--> */}
                                                        </div>
                                                        {/* <!--end::Col--> */}
                                                    </div>
                                                    {/* <!--end::Row--> */}
                                                </>
                                            )}
                                            {carRental['policyDetail']['ru_branchNotice'] && (
                                                <>
                                                    {/* <!--begin::Row--> */}
                                                    <div className='row mb-8'>
                                                        {/* <!--begin::Col--> */}
                                                        <div className='col-xl-3'>
                                                            <div className='fs-6 fw-bold mt-2 mb-3'>{t('Branch Notice (Russian)')}</div>
                                                        </div>
                                                        {/* <!--end::Col--> */}

                                                        {/* <!--begin::Col--> */}
                                                        <div className='col-xl-9'>
                                                            {/* <!--begin::Progress--> */}
                                                            <div className='d-flex flex-column'>
                                                                <div className=' fw-semibold text-gray-600 mt-3'>
                                                                    <div
                                                                        dangerouslySetInnerHTML={{
                                                                            __html: carRental['policyDetail']['ru_branchNotice'],
                                                                        }}
                                                                    ></div>
                                                                </div>
                                                            </div>
                                                            {/* <!--end::Progress--> */}
                                                        </div>
                                                        {/* <!--end::Col--> */}
                                                    </div>
                                                    {/* <!--end::Row--> */}
                                                </>
                                            )}
                                            {carRental['policyDetail']['uz_branchNotice'] && (
                                                <>
                                                    {/* <!--begin::Row--> */}
                                                    <div className='row mb-8'>
                                                        {/* <!--begin::Col--> */}
                                                        <div className='col-xl-3'>
                                                            <div className='fs-6 fw-bold mt-2 mb-3'>{t('Branch Notice (Uzbek)')}</div>
                                                        </div>
                                                        {/* <!--end::Col--> */}

                                                        {/* <!--begin::Col--> */}
                                                        <div className='col-xl-9'>
                                                            {/* <!--begin::Progress--> */}
                                                            <div className='d-flex flex-column'>
                                                                <div className=' fw-semibold text-gray-600 mt-3'>
                                                                    <div
                                                                        dangerouslySetInnerHTML={{
                                                                            __html: carRental['policyDetail']['uz_branchNotice'],
                                                                        }}
                                                                    ></div>
                                                                </div>
                                                            </div>
                                                            {/* <!--end::Progress--> */}
                                                        </div>
                                                        {/* <!--end::Col--> */}
                                                    </div>
                                                    {/* <!--end::Row--> */}
                                                </>
                                            )}
                                            {carRental['policyDetail']['en_aboutDeposits'] && (
                                                <>
                                                    {/* <!--begin::Row--> */}
                                                    <div className='row mb-8'>
                                                        {/* <!--begin::Col--> */}
                                                        <div className='col-xl-3'>
                                                            <div className='fs-6 fw-bold mt-2 mb-3'>{t('About Deposits (English)')}</div>
                                                        </div>
                                                        {/* <!--end::Col--> */}

                                                        {/* <!--begin::Col--> */}
                                                        <div className='col-xl-9'>
                                                            {/* <!--begin::Progress--> */}
                                                            <div className='d-flex flex-column'>
                                                                <div className=' fw-semibold text-gray-600 mt-3'>
                                                                    <div
                                                                        dangerouslySetInnerHTML={{
                                                                            __html: carRental['policyDetail']['en_aboutDeposits'],
                                                                        }}
                                                                    ></div>
                                                                </div>
                                                            </div>
                                                            {/* <!--end::Progress--> */}
                                                        </div>
                                                        {/* <!--end::Col--> */}
                                                    </div>
                                                    {/* <!--end::Row--> */}
                                                </>
                                            )}
                                            {carRental['policyDetail']['ru_aboutDeposits'] && (
                                                <>
                                                    {/* <!--begin::Row--> */}
                                                    <div className='row mb-8'>
                                                        {/* <!--begin::Col--> */}
                                                        <div className='col-xl-3'>
                                                            <div className='fs-6 fw-bold mt-2 mb-3'>{t('About Deposits (Russian)')}</div>
                                                        </div>
                                                        {/* <!--end::Col--> */}

                                                        {/* <!--begin::Col--> */}
                                                        <div className='col-xl-9'>
                                                            {/* <!--begin::Progress--> */}
                                                            <div className='d-flex flex-column'>
                                                                <div className=' fw-semibold text-gray-600 mt-3'>
                                                                    <div
                                                                        dangerouslySetInnerHTML={{
                                                                            __html: carRental['policyDetail']['ru_aboutDeposits'],
                                                                        }}
                                                                    ></div>
                                                                </div>
                                                            </div>
                                                            {/* <!--end::Progress--> */}
                                                        </div>
                                                        {/* <!--end::Col--> */}
                                                    </div>
                                                    {/* <!--end::Row--> */}
                                                </>
                                            )}
                                            {carRental['policyDetail']['uz_aboutDeposits'] && (
                                                <>
                                                    {/* <!--begin::Row--> */}
                                                    <div className='row mb-8'>
                                                        {/* <!--begin::Col--> */}
                                                        <div className='col-xl-3'>
                                                            <div className='fs-6 fw-bold mt-2 mb-3'>{t('About Deposits (Uzbek)')}</div>
                                                        </div>
                                                        {/* <!--end::Col--> */}

                                                        {/* <!--begin::Col--> */}
                                                        <div className='col-xl-9'>
                                                            {/* <!--begin::Progress--> */}
                                                            <div className='d-flex flex-column'>
                                                                <div className=' fw-semibold text-gray-600 mt-3'>
                                                                    <div
                                                                        dangerouslySetInnerHTML={{
                                                                            __html: carRental['policyDetail']['uz_aboutDeposits'],
                                                                        }}
                                                                    ></div>
                                                                </div>
                                                            </div>
                                                            {/* <!--end::Progress--> */}
                                                        </div>
                                                        {/* <!--end::Col--> */}
                                                    </div>
                                                    {/* <!--end::Row--> */}
                                                </>
                                            )}
                                        </div>
                                    </div>
                                    <div className='tab-content'>
                                        <div className={clsx('tab-pane', { active: tab === '2' })}>
                                            {carRental['policyDetail']['en_earlyPickUp'] && (
                                                <>
                                                    {/* <!--begin::Row--> */}
                                                    <div className='row mb-8'>
                                                        {/* <!--begin::Col--> */}
                                                        <div className='col-xl-3'>
                                                            <div className='fs-6 fw-bold mt-2 mb-3'>{t('Early Pick-Up (English)')}</div>
                                                        </div>
                                                        {/* <!--end::Col--> */}

                                                        {/* <!--begin::Col--> */}
                                                        <div className='col-xl-9'>
                                                            {/* <!--begin::Progress--> */}
                                                            <div className='d-flex flex-column'>
                                                                <div className=' fw-semibold text-gray-600 mt-3'>
                                                                    <div
                                                                        dangerouslySetInnerHTML={{
                                                                            __html: carRental['policyDetail']['en_earlyPickUp'],
                                                                        }}
                                                                    ></div>
                                                                </div>
                                                            </div>
                                                            {/* <!--end::Progress--> */}
                                                        </div>
                                                        {/* <!--end::Col--> */}
                                                    </div>
                                                    {/* <!--end::Row--> */}
                                                </>
                                            )}
                                            {carRental['policyDetail']['ru_earlyPickUp'] && (
                                                <>
                                                    {/* <!--begin::Row--> */}
                                                    <div className='row mb-8'>
                                                        {/* <!--begin::Col--> */}
                                                        <div className='col-xl-3'>
                                                            <div className='fs-6 fw-bold mt-2 mb-3'>{t('Early Pick-Up (Russian)')}</div>
                                                        </div>
                                                        {/* <!--end::Col--> */}

                                                        {/* <!--begin::Col--> */}
                                                        <div className='col-xl-9'>
                                                            {/* <!--begin::Progress--> */}
                                                            <div className='d-flex flex-column'>
                                                                <div className=' fw-semibold text-gray-600 mt-3'>
                                                                    <div
                                                                        dangerouslySetInnerHTML={{
                                                                            __html: carRental['policyDetail']['ru_earlyPickUp'],
                                                                        }}
                                                                    ></div>
                                                                </div>
                                                            </div>
                                                            {/* <!--end::Progress--> */}
                                                        </div>
                                                        {/* <!--end::Col--> */}
                                                    </div>
                                                    {/* <!--end::Row--> */}
                                                </>
                                            )}
                                            {carRental['policyDetail']['uz_earlyPickUp'] && (
                                                <>
                                                    {/* <!--begin::Row--> */}
                                                    <div className='row mb-8'>
                                                        {/* <!--begin::Col--> */}
                                                        <div className='col-xl-3'>
                                                            <div className='fs-6 fw-bold mt-2 mb-3'>{t('Early Pick-Up (Uzbek)')}</div>
                                                        </div>
                                                        {/* <!--end::Col--> */}

                                                        {/* <!--begin::Col--> */}
                                                        <div className='col-xl-9'>
                                                            {/* <!--begin::Progress--> */}
                                                            <div className='d-flex flex-column'>
                                                                <div className=' fw-semibold text-gray-600 mt-3'>
                                                                    <div
                                                                        dangerouslySetInnerHTML={{
                                                                            __html: carRental['policyDetail']['uz_earlyPickUp'],
                                                                        }}
                                                                    ></div>
                                                                </div>
                                                            </div>
                                                            {/* <!--end::Progress--> */}
                                                        </div>
                                                        {/* <!--end::Col--> */}
                                                    </div>
                                                    {/* <!--end::Row--> */}
                                                </>
                                            )}
                                            {carRental['policyDetail']['en_latePickUp'] && (
                                                <>
                                                    {/* <!--begin::Row--> */}
                                                    <div className='row mb-8'>
                                                        {/* <!--begin::Col--> */}
                                                        <div className='col-xl-3'>
                                                            <div className='fs-6 fw-bold mt-2 mb-3'>{t('Late Pick-Up (English)')}</div>
                                                        </div>
                                                        {/* <!--end::Col--> */}

                                                        {/* <!--begin::Col--> */}
                                                        <div className='col-xl-9'>
                                                            {/* <!--begin::Progress--> */}
                                                            <div className='d-flex flex-column'>
                                                                <div className=' fw-semibold text-gray-600 mt-3'>
                                                                    <div
                                                                        dangerouslySetInnerHTML={{
                                                                            __html: carRental['policyDetail']['en_latePickUp'],
                                                                        }}
                                                                    ></div>
                                                                </div>
                                                            </div>
                                                            {/* <!--end::Progress--> */}
                                                        </div>
                                                        {/* <!--end::Col--> */}
                                                    </div>
                                                    {/* <!--end::Row--> */}
                                                </>
                                            )}
                                            {carRental['policyDetail']['ru_latePickUp'] && (
                                                <>
                                                    {/* <!--begin::Row--> */}
                                                    <div className='row mb-8'>
                                                        {/* <!--begin::Col--> */}
                                                        <div className='col-xl-3'>
                                                            <div className='fs-6 fw-bold mt-2 mb-3'>{t('Late Pick-Up (Russian)')}</div>
                                                        </div>
                                                        {/* <!--end::Col--> */}

                                                        {/* <!--begin::Col--> */}
                                                        <div className='col-xl-9'>
                                                            {/* <!--begin::Progress--> */}
                                                            <div className='d-flex flex-column'>
                                                                <div className=' fw-semibold text-gray-600 mt-3'>
                                                                    <div
                                                                        dangerouslySetInnerHTML={{
                                                                            __html: carRental['policyDetail']['ru_latePickUp'],
                                                                        }}
                                                                    ></div>
                                                                </div>
                                                            </div>
                                                            {/* <!--end::Progress--> */}
                                                        </div>
                                                        {/* <!--end::Col--> */}
                                                    </div>
                                                    {/* <!--end::Row--> */}
                                                </>
                                            )}
                                            {carRental['policyDetail']['uz_latePickUp'] && (
                                                <>
                                                    {/* <!--begin::Row--> */}
                                                    <div className='row mb-8'>
                                                        {/* <!--begin::Col--> */}
                                                        <div className='col-xl-3'>
                                                            <div className='fs-6 fw-bold mt-2 mb-3'>{t('Late Pick-Up (Uzbek)')}</div>
                                                        </div>
                                                        {/* <!--end::Col--> */}

                                                        {/* <!--begin::Col--> */}
                                                        <div className='col-xl-9'>
                                                            {/* <!--begin::Progress--> */}
                                                            <div className='d-flex flex-column'>
                                                                <div className=' fw-semibold text-gray-600 mt-3'>
                                                                    <div
                                                                        dangerouslySetInnerHTML={{
                                                                            __html: carRental['policyDetail']['uz_latePickUp'],
                                                                        }}
                                                                    ></div>
                                                                </div>
                                                            </div>
                                                            {/* <!--end::Progress--> */}
                                                        </div>
                                                        {/* <!--end::Col--> */}
                                                    </div>
                                                    {/* <!--end::Row--> */}
                                                </>
                                            )}
                                            {carRental['policyDetail']['en_earlyDropOff'] && (
                                                <>
                                                    {/* <!--begin::Row--> */}
                                                    <div className='row mb-8'>
                                                        {/* <!--begin::Col--> */}
                                                        <div className='col-xl-3'>
                                                            <div className='fs-6 fw-bold mt-2 mb-3'>{t('Early Drop-Off (English)')}</div>
                                                        </div>
                                                        {/* <!--end::Col--> */}

                                                        {/* <!--begin::Col--> */}
                                                        <div className='col-xl-9'>
                                                            {/* <!--begin::Progress--> */}
                                                            <div className='d-flex flex-column'>
                                                                <div className=' fw-semibold text-gray-600 mt-3'>
                                                                    <div
                                                                        dangerouslySetInnerHTML={{
                                                                            __html: carRental['policyDetail']['en_earlyDropOff'],
                                                                        }}
                                                                    ></div>
                                                                </div>
                                                            </div>
                                                            {/* <!--end::Progress--> */}
                                                        </div>
                                                        {/* <!--end::Col--> */}
                                                    </div>
                                                    {/* <!--end::Row--> */}
                                                </>
                                            )}
                                            {carRental['policyDetail']['ru_earlyDropOff'] && (
                                                <>
                                                    {/* <!--begin::Row--> */}
                                                    <div className='row mb-8'>
                                                        {/* <!--begin::Col--> */}
                                                        <div className='col-xl-3'>
                                                            <div className='fs-6 fw-bold mt-2 mb-3'>{t('Early Drop-Off (Russian)')}</div>
                                                        </div>
                                                        {/* <!--end::Col--> */}

                                                        {/* <!--begin::Col--> */}
                                                        <div className='col-xl-9'>
                                                            {/* <!--begin::Progress--> */}
                                                            <div className='d-flex flex-column'>
                                                                <div className=' fw-semibold text-gray-600 mt-3'>
                                                                    <div
                                                                        dangerouslySetInnerHTML={{
                                                                            __html: carRental['policyDetail']['ru_earlyDropOff'],
                                                                        }}
                                                                    ></div>
                                                                </div>
                                                            </div>
                                                            {/* <!--end::Progress--> */}
                                                        </div>
                                                        {/* <!--end::Col--> */}
                                                    </div>
                                                    {/* <!--end::Row--> */}
                                                </>
                                            )}
                                            {carRental['policyDetail']['uz_earlyDropOff'] && (
                                                <>
                                                    {/* <!--begin::Row--> */}
                                                    <div className='row mb-8'>
                                                        {/* <!--begin::Col--> */}
                                                        <div className='col-xl-3'>
                                                            <div className='fs-6 fw-bold mt-2 mb-3'>{t('Early Drop-Off (Uzbek)')}</div>
                                                        </div>
                                                        {/* <!--end::Col--> */}

                                                        {/* <!--begin::Col--> */}
                                                        <div className='col-xl-9'>
                                                            {/* <!--begin::Progress--> */}
                                                            <div className='d-flex flex-column'>
                                                                <div className=' fw-semibold text-gray-600 mt-3'>
                                                                    <div
                                                                        dangerouslySetInnerHTML={{
                                                                            __html: carRental['policyDetail']['uz_earlyDropOff'],
                                                                        }}
                                                                    ></div>
                                                                </div>
                                                            </div>
                                                            {/* <!--end::Progress--> */}
                                                        </div>
                                                        {/* <!--end::Col--> */}
                                                    </div>
                                                    {/* <!--end::Row--> */}
                                                </>
                                            )}
                                            {carRental['policyDetail']['en_lateDropOff'] && (
                                                <>
                                                    {/* <!--begin::Row--> */}
                                                    <div className='row mb-8'>
                                                        {/* <!--begin::Col--> */}
                                                        <div className='col-xl-3'>
                                                            <div className='fs-6 fw-bold mt-2 mb-3'>{t('Late Drop-Off (English)')}</div>
                                                        </div>
                                                        {/* <!--end::Col--> */}

                                                        {/* <!--begin::Col--> */}
                                                        <div className='col-xl-9'>
                                                            {/* <!--begin::Progress--> */}
                                                            <div className='d-flex flex-column'>
                                                                <div className=' fw-semibold text-gray-600 mt-3'>
                                                                    <div
                                                                        dangerouslySetInnerHTML={{
                                                                            __html: carRental['policyDetail']['en_lateDropOff'],
                                                                        }}
                                                                    ></div>
                                                                </div>
                                                            </div>
                                                            {/* <!--end::Progress--> */}
                                                        </div>
                                                        {/* <!--end::Col--> */}
                                                    </div>
                                                    {/* <!--end::Row--> */}
                                                </>
                                            )}
                                            {carRental['policyDetail']['ru_lateDropOff'] && (
                                                <>
                                                    {/* <!--begin::Row--> */}
                                                    <div className='row mb-8'>
                                                        {/* <!--begin::Col--> */}
                                                        <div className='col-xl-3'>
                                                            <div className='fs-6 fw-bold mt-2 mb-3'>{t('Late Drop-Off (Russian)')}</div>
                                                        </div>
                                                        {/* <!--end::Col--> */}

                                                        {/* <!--begin::Col--> */}
                                                        <div className='col-xl-9'>
                                                            {/* <!--begin::Progress--> */}
                                                            <div className='d-flex flex-column'>
                                                                <div className=' fw-semibold text-gray-600 mt-3'>
                                                                    <div
                                                                        dangerouslySetInnerHTML={{
                                                                            __html: carRental['policyDetail']['ru_lateDropOff'],
                                                                        }}
                                                                    ></div>
                                                                </div>
                                                            </div>
                                                            {/* <!--end::Progress--> */}
                                                        </div>
                                                        {/* <!--end::Col--> */}
                                                    </div>
                                                    {/* <!--end::Row--> */}
                                                </>
                                            )}
                                            {carRental['policyDetail']['uz_lateDropOff'] && (
                                                <>
                                                    {/* <!--begin::Row--> */}
                                                    <div className='row mb-8'>
                                                        {/* <!--begin::Col--> */}
                                                        <div className='col-xl-3'>
                                                            <div className='fs-6 fw-bold mt-2 mb-3'>{t('Late Drop-Off (Uzbek)')}</div>
                                                        </div>
                                                        {/* <!--end::Col--> */}

                                                        {/* <!--begin::Col--> */}
                                                        <div className='col-xl-9'>
                                                            {/* <!--begin::Progress--> */}
                                                            <div className='d-flex flex-column'>
                                                                <div className=' fw-semibold text-gray-600 mt-3'>
                                                                    <div
                                                                        dangerouslySetInnerHTML={{
                                                                            __html: carRental['policyDetail']['uz_lateDropOff'],
                                                                        }}
                                                                    ></div>
                                                                </div>
                                                            </div>
                                                            {/* <!--end::Progress--> */}
                                                        </div>
                                                        {/* <!--end::Col--> */}
                                                    </div>
                                                    {/* <!--end::Row--> */}
                                                </>
                                            )}
                                        </div>
                                    </div>
                                    <div className='tab-content'>
                                        <div className={clsx('tab-pane', { active: tab === '3' })}>
                                            {carRental['policyDetail']['en_confirmationPolicy'] && (
                                                <>
                                                    {/* <!--begin::Row--> */}
                                                    <div className='row mb-8'>
                                                        {/* <!--begin::Col--> */}
                                                        <div className='col-xl-3'>
                                                            <div className='fs-6 fw-bold mt-2 mb-3'>{t('Confirmation Policy (English)')}</div>
                                                        </div>
                                                        {/* <!--end::Col--> */}

                                                        {/* <!--begin::Col--> */}
                                                        <div className='col-xl-9'>
                                                            {/* <!--begin::Progress--> */}
                                                            <div className='d-flex flex-column'>
                                                                <div className=' fw-semibold text-gray-600 mt-3'>
                                                                    <div
                                                                        dangerouslySetInnerHTML={{
                                                                            __html: carRental['policyDetail']['en_confirmationPolicy'],
                                                                        }}
                                                                    ></div>
                                                                </div>
                                                            </div>
                                                            {/* <!--end::Progress--> */}
                                                        </div>
                                                        {/* <!--end::Col--> */}
                                                    </div>
                                                    {/* <!--end::Row--> */}
                                                </>
                                            )}
                                            {carRental['policyDetail']['ru_confirmationPolicy'] && (
                                                <>
                                                    {/* <!--begin::Row--> */}
                                                    <div className='row mb-8'>
                                                        {/* <!--begin::Col--> */}
                                                        <div className='col-xl-3'>
                                                            <div className='fs-6 fw-bold mt-2 mb-3'>{t('Confirmation Policy (Russian)')}</div>
                                                        </div>
                                                        {/* <!--end::Col--> */}

                                                        {/* <!--begin::Col--> */}
                                                        <div className='col-xl-9'>
                                                            {/* <!--begin::Progress--> */}
                                                            <div className='d-flex flex-column'>
                                                                <div className=' fw-semibold text-gray-600 mt-3'>
                                                                    <div
                                                                        dangerouslySetInnerHTML={{
                                                                            __html: carRental['policyDetail']['ru_confirmationPolicy'],
                                                                        }}
                                                                    ></div>
                                                                </div>
                                                            </div>
                                                            {/* <!--end::Progress--> */}
                                                        </div>
                                                        {/* <!--end::Col--> */}
                                                    </div>
                                                    {/* <!--end::Row--> */}
                                                </>
                                            )}
                                            {carRental['policyDetail']['uz_confirmationPolicy'] && (
                                                <>
                                                    {/* <!--begin::Row--> */}
                                                    <div className='row mb-8'>
                                                        {/* <!--begin::Col--> */}
                                                        <div className='col-xl-3'>
                                                            <div className='fs-6 fw-bold mt-2 mb-3'>{t('Confirmation Policy (Uzbek)')}</div>
                                                        </div>
                                                        {/* <!--end::Col--> */}

                                                        {/* <!--begin::Col--> */}
                                                        <div className='col-xl-9'>
                                                            {/* <!--begin::Progress--> */}
                                                            <div className='d-flex flex-column'>
                                                                <div className=' fw-semibold text-gray-600 mt-3'>
                                                                    <div
                                                                        dangerouslySetInnerHTML={{
                                                                            __html: carRental['policyDetail']['uz_confirmationPolicy'],
                                                                        }}
                                                                    ></div>
                                                                </div>
                                                            </div>
                                                            {/* <!--end::Progress--> */}
                                                        </div>
                                                        {/* <!--end::Col--> */}
                                                    </div>
                                                    {/* <!--end::Row--> */}
                                                </>
                                            )}
                                            {carRental['policyDetail']['en_contractAmountCheck'] && (
                                                <>
                                                    {/* <!--begin::Row--> */}
                                                    <div className='row mb-8'>
                                                        {/* <!--begin::Col--> */}
                                                        <div className='col-xl-3'>
                                                            <div className='fs-6 fw-bold mt-2 mb-3'>
                                                                {t('Contract Amount Check (English)')}
                                                            </div>
                                                        </div>
                                                        {/* <!--end::Col--> */}

                                                        {/* <!--begin::Col--> */}
                                                        <div className='col-xl-9'>
                                                            {/* <!--begin::Progress--> */}
                                                            <div className='d-flex flex-column'>
                                                                <div className=' fw-semibold text-gray-600 mt-3'>
                                                                    <div
                                                                        dangerouslySetInnerHTML={{
                                                                            __html: carRental['policyDetail']['en_contractAmountCheck'],
                                                                        }}
                                                                    ></div>
                                                                </div>
                                                            </div>
                                                            {/* <!--end::Progress--> */}
                                                        </div>
                                                        {/* <!--end::Col--> */}
                                                    </div>
                                                    {/* <!--end::Row--> */}
                                                </>
                                            )}
                                            {carRental['policyDetail']['ru_contractAmountCheck'] && (
                                                <>
                                                    {/* <!--begin::Row--> */}
                                                    <div className='row mb-8'>
                                                        {/* <!--begin::Col--> */}
                                                        <div className='col-xl-3'>
                                                            <div className='fs-6 fw-bold mt-2 mb-3'>
                                                                {t('Contract Amount Check (Russian)')}
                                                            </div>
                                                        </div>
                                                        {/* <!--end::Col--> */}

                                                        {/* <!--begin::Col--> */}
                                                        <div className='col-xl-9'>
                                                            {/* <!--begin::Progress--> */}
                                                            <div className='d-flex flex-column'>
                                                                <div className=' fw-semibold text-gray-600 mt-3'>
                                                                    <div
                                                                        dangerouslySetInnerHTML={{
                                                                            __html: carRental['policyDetail']['ru_contractAmountCheck'],
                                                                        }}
                                                                    ></div>
                                                                </div>
                                                            </div>
                                                            {/* <!--end::Progress--> */}
                                                        </div>
                                                        {/* <!--end::Col--> */}
                                                    </div>
                                                    {/* <!--end::Row--> */}
                                                </>
                                            )}
                                            {carRental['policyDetail']['uz_contractAmountCheck'] && (
                                                <>
                                                    {/* <!--begin::Row--> */}
                                                    <div className='row mb-8'>
                                                        {/* <!--begin::Col--> */}
                                                        <div className='col-xl-3'>
                                                            <div className='fs-6 fw-bold mt-2 mb-3'>{t('Contract Amount Check (Uzbek)')}</div>
                                                        </div>
                                                        {/* <!--end::Col--> */}

                                                        {/* <!--begin::Col--> */}
                                                        <div className='col-xl-9'>
                                                            {/* <!--begin::Progress--> */}
                                                            <div className='d-flex flex-column'>
                                                                <div className=' fw-semibold text-gray-600 mt-3'>
                                                                    <div
                                                                        dangerouslySetInnerHTML={{
                                                                            __html: carRental['policyDetail']['uz_contractAmountCheck'],
                                                                        }}
                                                                    ></div>
                                                                </div>
                                                            </div>
                                                            {/* <!--end::Progress--> */}
                                                        </div>
                                                        {/* <!--end::Col--> */}
                                                    </div>
                                                    {/* <!--end::Row--> */}
                                                </>
                                            )}
                                            {carRental['policyDetail']['en_inspectionGuidelines'] && (
                                                <>
                                                    {/* <!--begin::Row--> */}
                                                    <div className='row mb-8'>
                                                        {/* <!--begin::Col--> */}
                                                        <div className='col-xl-3'>
                                                            <div className='fs-6 fw-bold mt-2 mb-3'>
                                                                {t('Inspection Guide Lines (English)')}
                                                            </div>
                                                        </div>
                                                        {/* <!--end::Col--> */}

                                                        {/* <!--begin::Col--> */}
                                                        <div className='col-xl-9'>
                                                            {/* <!--begin::Progress--> */}
                                                            <div className='d-flex flex-column'>
                                                                <div className=' fw-semibold text-gray-600 mt-3'>
                                                                    <div
                                                                        dangerouslySetInnerHTML={{
                                                                            __html: carRental['policyDetail']['en_inspectionGuidelines'],
                                                                        }}
                                                                    ></div>
                                                                </div>
                                                            </div>
                                                            {/* <!--end::Progress--> */}
                                                        </div>
                                                        {/* <!--end::Col--> */}
                                                    </div>
                                                    {/* <!--end::Row--> */}
                                                </>
                                            )}
                                            {carRental['policyDetail']['ru_inspectionGuidelines'] && (
                                                <>
                                                    {/* <!--begin::Row--> */}
                                                    <div className='row mb-8'>
                                                        {/* <!--begin::Col--> */}
                                                        <div className='col-xl-3'>
                                                            <div className='fs-6 fw-bold mt-2 mb-3'>
                                                                {t('Inspection Guide Lines (Russian)')}
                                                            </div>
                                                        </div>
                                                        {/* <!--end::Col--> */}

                                                        {/* <!--begin::Col--> */}
                                                        <div className='col-xl-9'>
                                                            {/* <!--begin::Progress--> */}
                                                            <div className='d-flex flex-column'>
                                                                <div className=' fw-semibold text-gray-600 mt-3'>
                                                                    <div
                                                                        dangerouslySetInnerHTML={{
                                                                            __html: carRental['policyDetail']['ru_inspectionGuidelines'],
                                                                        }}
                                                                    ></div>
                                                                </div>
                                                            </div>
                                                            {/* <!--end::Progress--> */}
                                                        </div>
                                                        {/* <!--end::Col--> */}
                                                    </div>
                                                    {/* <!--end::Row--> */}
                                                </>
                                            )}
                                            {carRental['policyDetail']['uz_inspectionGuidelines'] && (
                                                <>
                                                    {/* <!--begin::Row--> */}
                                                    <div className='row mb-8'>
                                                        {/* <!--begin::Col--> */}
                                                        <div className='col-xl-3'>
                                                            <div className='fs-6 fw-bold mt-2 mb-3'>{t('Inspection Guide Lines (Uzbek)')}</div>
                                                        </div>
                                                        {/* <!--end::Col--> */}

                                                        {/* <!--begin::Col--> */}
                                                        <div className='col-xl-9'>
                                                            {/* <!--begin::Progress--> */}
                                                            <div className='d-flex flex-column'>
                                                                <div className=' fw-semibold text-gray-600 mt-3'>
                                                                    <div
                                                                        dangerouslySetInnerHTML={{
                                                                            __html: carRental['policyDetail']['uz_inspectionGuidelines'],
                                                                        }}
                                                                    ></div>
                                                                </div>
                                                            </div>
                                                            {/* <!--end::Progress--> */}
                                                        </div>
                                                        {/* <!--end::Col--> */}
                                                    </div>
                                                    {/* <!--end::Row--> */}
                                                </>
                                            )}
                                        </div>
                                    </div>
                                    <div className='tab-content'>
                                        <div className={clsx('tab-pane', { active: tab === '4' })}>
                                            {carRental['policyDetail']['en_extras'] && (
                                                <>
                                                    {/* <!--begin::Row--> */}
                                                    <div className='row mb-8'>
                                                        {/* <!--begin::Col--> */}
                                                        <div className='col-xl-3'>
                                                            <div className='fs-6 fw-bold mt-2 mb-3'>{t('Extras (English)')}</div>
                                                        </div>
                                                        {/* <!--end::Col--> */}

                                                        {/* <!--begin::Col--> */}
                                                        <div className='col-xl-9'>
                                                            {/* <!--begin::Progress--> */}
                                                            <div className='d-flex flex-column'>
                                                                <div className=' fw-semibold text-gray-600 mt-3'>
                                                                    <div
                                                                        dangerouslySetInnerHTML={{
                                                                            __html: carRental['policyDetail']['en_extras'],
                                                                        }}
                                                                    ></div>
                                                                </div>
                                                            </div>
                                                            {/* <!--end::Progress--> */}
                                                        </div>
                                                        {/* <!--end::Col--> */}
                                                    </div>
                                                    {/* <!--end::Row--> */}
                                                </>
                                            )}
                                            {carRental['policyDetail']['ru_extras'] && (
                                                <>
                                                    {/* <!--begin::Row--> */}
                                                    <div className='row mb-8'>
                                                        {/* <!--begin::Col--> */}
                                                        <div className='col-xl-3'>
                                                            <div className='fs-6 fw-bold mt-2 mb-3'>{t('Extras (Russian)')}</div>
                                                        </div>
                                                        {/* <!--end::Col--> */}

                                                        {/* <!--begin::Col--> */}
                                                        <div className='col-xl-9'>
                                                            {/* <!--begin::Progress--> */}
                                                            <div className='d-flex flex-column'>
                                                                <div className=' fw-semibold text-gray-600 mt-3'>
                                                                    <div
                                                                        dangerouslySetInnerHTML={{
                                                                            __html: carRental['policyDetail']['ru_extras'],
                                                                        }}
                                                                    ></div>
                                                                </div>
                                                            </div>
                                                            {/* <!--end::Progress--> */}
                                                        </div>
                                                        {/* <!--end::Col--> */}
                                                    </div>
                                                    {/* <!--end::Row--> */}
                                                </>
                                            )}
                                            {carRental['policyDetail']['uz_extras'] && (
                                                <>
                                                    {/* <!--begin::Row--> */}
                                                    <div className='row mb-8'>
                                                        {/* <!--begin::Col--> */}
                                                        <div className='col-xl-3'>
                                                            <div className='fs-6 fw-bold mt-2 mb-3'>{t('Extras (Uzbek)')}</div>
                                                        </div>
                                                        {/* <!--end::Col--> */}

                                                        {/* <!--begin::Col--> */}
                                                        <div className='col-xl-9'>
                                                            {/* <!--begin::Progress--> */}
                                                            <div className='d-flex flex-column'>
                                                                <div className=' fw-semibold text-gray-600 mt-3'>
                                                                    <div
                                                                        dangerouslySetInnerHTML={{
                                                                            __html: carRental['policyDetail']['uz_extras'],
                                                                        }}
                                                                    ></div>
                                                                </div>
                                                            </div>
                                                            {/* <!--end::Progress--> */}
                                                        </div>
                                                        {/* <!--end::Col--> */}
                                                    </div>
                                                    {/* <!--end::Row--> */}
                                                </>
                                            )}
                                            {carRental['policyDetail']['en_texesAndFees'] && (
                                                <>
                                                    {/* <!--begin::Row--> */}
                                                    <div className='row mb-8'>
                                                        {/* <!--begin::Col--> */}
                                                        <div className='col-xl-3'>
                                                            <div className='fs-6 fw-bold mt-2 mb-3'>{t('Taxes And Fees (English)')}</div>
                                                        </div>
                                                        {/* <!--end::Col--> */}

                                                        {/* <!--begin::Col--> */}
                                                        <div className='col-xl-9'>
                                                            {/* <!--begin::Progress--> */}
                                                            <div className='d-flex flex-column'>
                                                                <div className=' fw-semibold text-gray-600 mt-3'>
                                                                    <div
                                                                        dangerouslySetInnerHTML={{
                                                                            __html: carRental['policyDetail']['en_texesAndFees'],
                                                                        }}
                                                                    ></div>
                                                                </div>
                                                            </div>
                                                            {/* <!--end::Progress--> */}
                                                        </div>
                                                        {/* <!--end::Col--> */}
                                                    </div>
                                                    {/* <!--end::Row--> */}
                                                </>
                                            )}
                                            {carRental['policyDetail']['ru_texesAndFees'] && (
                                                <>
                                                    {/* <!--begin::Row--> */}
                                                    <div className='row mb-8'>
                                                        {/* <!--begin::Col--> */}
                                                        <div className='col-xl-3'>
                                                            <div className='fs-6 fw-bold mt-2 mb-3'>{t('Taxes And Fees (Russian)')}</div>
                                                        </div>
                                                        {/* <!--end::Col--> */}

                                                        {/* <!--begin::Col--> */}
                                                        <div className='col-xl-9'>
                                                            {/* <!--begin::Progress--> */}
                                                            <div className='d-flex flex-column'>
                                                                <div className=' fw-semibold text-gray-600 mt-3'>
                                                                    <div
                                                                        dangerouslySetInnerHTML={{
                                                                            __html: carRental['policyDetail']['ru_texesAndFees'],
                                                                        }}
                                                                    ></div>
                                                                </div>
                                                            </div>
                                                            {/* <!--end::Progress--> */}
                                                        </div>
                                                        {/* <!--end::Col--> */}
                                                    </div>
                                                    {/* <!--end::Row--> */}
                                                </>
                                            )}
                                            {carRental['policyDetail']['uz_texesAndFees'] && (
                                                <>
                                                    {/* <!--begin::Row--> */}
                                                    <div className='row mb-8'>
                                                        {/* <!--begin::Col--> */}
                                                        <div className='col-xl-3'>
                                                            <div className='fs-6 fw-bold mt-2 mb-3'>{t('Taxes And Fees (Uzbek)')}</div>
                                                        </div>
                                                        {/* <!--end::Col--> */}

                                                        {/* <!--begin::Col--> */}
                                                        <div className='col-xl-9'>
                                                            {/* <!--begin::Progress--> */}
                                                            <div className='d-flex flex-column'>
                                                                <div className=' fw-semibold text-gray-600 mt-3'>
                                                                    <div
                                                                        dangerouslySetInnerHTML={{
                                                                            __html: carRental['policyDetail']['uz_texesAndFees'],
                                                                        }}
                                                                    ></div>
                                                                </div>
                                                            </div>
                                                            {/* <!--end::Progress--> */}
                                                        </div>
                                                        {/* <!--end::Col--> */}
                                                    </div>
                                                    {/* <!--end::Row--> */}
                                                </>
                                            )}
                                        </div>
                                    </div>
                                    <div className='tab-content'>
                                        <div className={clsx('tab-pane', { active: tab === '5' })}>
                                            {/* {carRental['policyDetail']['en_modifictions'] && (
                                                <>
                                                    
                                                    <div className='row mb-8'>
                                                        
                                                        <div className='col-xl-3'>
                                                            <div className='fs-6 fw-bold mt-2 mb-3'>{t('Modifications (English)')}</div>
                                                        </div>
                                                        

                                                        
                                                        <div className='col-xl-9'>
                                                            
                                                            <div className='d-flex flex-column'>
                                                                <div className=' fw-semibold text-gray-600 mt-3'>
                                                                    <div
                                                                        dangerouslySetInnerHTML={{
                                                                            __html: carRental['policyDetail']['en_modifictions'],
                                                                        }}
                                                                    ></div>
                                                                </div>
                                                            </div>
                                                            
                                                        </div>
                                                        
                                                    </div>
                                                    
                                                </>
                                            )}
                                            {carRental['policyDetail']['ru_modifictions'] && (
                                                <>
                                                    
                                                    <div className='row mb-8'>
                                                        
                                                        <div className='col-xl-3'>
                                                            <div className='fs-6 fw-bold mt-2 mb-3'>{t('Modifications (Russian)')}</div>
                                                        </div>
                                                        

                                                        
                                                        <div className='col-xl-9'>
                                                            
                                                            <div className='d-flex flex-column'>
                                                                <div className=' fw-semibold text-gray-600 mt-3'>
                                                                    <div
                                                                        dangerouslySetInnerHTML={{
                                                                            __html: carRental['policyDetail']['ru_modifictions'],
                                                                        }}
                                                                    ></div>
                                                                </div>
                                                            </div>
                                                            
                                                        </div>
                                                        
                                                    </div>
                                                    
                                                </>
                                            )}
                                            {carRental['policyDetail']['uz_modifictions'] && (
                                                <>
                                                    
                                                    <div className='row mb-8'>
                                                        
                                                        <div className='col-xl-3'>
                                                            <div className='fs-6 fw-bold mt-2 mb-3'>{t('Modifications (Uzbek)')}</div>
                                                        </div>
                                                        

                                                        
                                                        <div className='col-xl-9'>
                                                            
                                                            <div className='d-flex flex-column'>
                                                                <div className=' fw-semibold text-gray-600 mt-3'>
                                                                    <div
                                                                        dangerouslySetInnerHTML={{
                                                                            __html: carRental['policyDetail']['uz_modifictions'],
                                                                        }}
                                                                    ></div>
                                                                </div>
                                                            </div>
                                                            
                                                        </div>
                                                        
                                                    </div>
                                                    
                                                </>
                                            )}
                                            {carRental['policyDetail']['en_noShows'] && (
                                                <>
                                                    
                                                    <div className='row mb-8'>
                                                        
                                                        <div className='col-xl-3'>
                                                            <div className='fs-6 fw-bold mt-2 mb-3'>{t('No Shows (English)')}</div>
                                                        </div>
                                                        

                                                        
                                                        <div className='col-xl-9'>
                                                            
                                                            <div className='d-flex flex-column'>
                                                                <div className=' fw-semibold text-gray-600 mt-3'>
                                                                    <div
                                                                        dangerouslySetInnerHTML={{
                                                                            __html: carRental['policyDetail']['en_noShows'],
                                                                        }}
                                                                    ></div>
                                                                </div>
                                                            </div>
                                                            
                                                        </div>
                                                        
                                                    </div>
                                                    
                                                </>
                                            )}
                                            {carRental['policyDetail']['ru_noShows'] && (
                                                <>
                                                    
                                                    <div className='row mb-8'>
                                                        
                                                        <div className='col-xl-3'>
                                                            <div className='fs-6 fw-bold mt-2 mb-3'>{t('No Shows (Russian)')}</div>
                                                        </div>
                                                        

                                                        
                                                        <div className='col-xl-9'>
                                                            
                                                            <div className='d-flex flex-column'>
                                                                <div className=' fw-semibold text-gray-600 mt-3'>
                                                                    <div
                                                                        dangerouslySetInnerHTML={{
                                                                            __html: carRental['policyDetail']['ru_noShows'],
                                                                        }}
                                                                    ></div>
                                                                </div>
                                                            </div>
                                                            
                                                        </div>
                                                    </div>
                                                </>
                                            )}
                                            {carRental['policyDetail']['uz_noShows'] && (
                                                <>
                                                    <div className='row mb-8'>
                                                        <div className='col-xl-3'>
                                                            <div className='fs-6 fw-bold mt-2 mb-3'>{t('No Shows (Uzbek)')}</div>
                                                        </div>

                                                        <div className='col-xl-9'>
                                                            <div className='d-flex flex-column'>
                                                                <div className=' fw-semibold text-gray-600 mt-3'>
                                                                    <div
                                                                        dangerouslySetInnerHTML={{
                                                                            __html: carRental['policyDetail']['uz_noShows'],
                                                                        }}
                                                                    ></div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </>
                                            )} */}
                                            {carRental['policyDetail']['en_cancellation'] && (
                                                <>
                                                    
                                                    <div className='row mb-8'>
                                                        {/* <!--begin::Col--> */}
                                                        <div className='col-xl-3'>
                                                            <div className='fs-6 fw-bold mt-2 mb-3'>{t('Cancellation (English)')}</div>
                                                        </div>
                                                        {/* <!--end::Col--> */}

                                                        {/* <!--begin::Col--> */}
                                                        <div className='col-xl-9'>
                                                            
                                                            <div className='d-flex flex-column'>
                                                                <div className=' fw-semibold text-gray-600 mt-3'>
                                                                    <div
                                                                        dangerouslySetInnerHTML={{
                                                                            __html: carRental['policyDetail']['en_cancellation'],
                                                                        }}
                                                                    ></div>
                                                                </div>
                                                            </div>
                                                            
                                                        </div>
                                                        {/* <!--end::Col--> */}
                                                    </div>
                                                    
                                                </>
                                            )}
                                            {carRental['policyDetail']['ru_cancellation'] && (
                                                <>
                                                    {/* <!--begin::Row--> */}
                                                    <div className='row mb-8'>
                                                        {/* <!--begin::Col--> */}
                                                        <div className='col-xl-3'>
                                                            <div className='fs-6 fw-bold mt-2 mb-3'>{t('Cancellation (Russian)')}</div>
                                                        </div>
                                                        {/* <!--end::Col--> */}

                                                        {/* <!--begin::Col--> */}
                                                        <div className='col-xl-9'>
                                                            {/* <!--begin::Progress--> */}
                                                            <div className='d-flex flex-column'>
                                                                <div className=' fw-semibold text-gray-600 mt-3'>
                                                                    <div
                                                                        dangerouslySetInnerHTML={{
                                                                            __html: carRental['policyDetail']['ru_cancellation'],
                                                                        }}
                                                                    ></div>
                                                                </div>
                                                            </div>
                                                            {/* <!--end::Progress--> */}
                                                        </div>
                                                        {/* <!--end::Col--> */}
                                                    </div>
                                                    {/* <!--end::Row--> */}
                                                </>
                                            )}
                                            {carRental['policyDetail']['uz_cancellation'] && (
                                                <>
                                                    {/* <!--begin::Row--> */}
                                                    <div className='row mb-8'>
                                                        {/* <!--begin::Col--> */}
                                                        <div className='col-xl-3'>
                                                            <div className='fs-6 fw-bold mt-2 mb-3'>{t('Cancellation (Uzbek)')}</div>
                                                        </div>
                                                        {/* <!--end::Col--> */}

                                                        {/* <!--begin::Col--> */}
                                                        <div className='col-xl-9'>
                                                            {/* <!--begin::Progress--> */}
                                                            <div className='d-flex flex-column'>
                                                                <div className=' fw-semibold text-gray-600 mt-3'>
                                                                    <div
                                                                        dangerouslySetInnerHTML={{
                                                                            __html: carRental['policyDetail']['uz_cancellation'],
                                                                        }}
                                                                    ></div>
                                                                </div>
                                                            </div>
                                                            {/* <!--end::Progress--> */}
                                                        </div>
                                                        {/* <!--end::Col--> */}
                                                    </div>
                                                    {/* <!--end::Row--> */}
                                                </>
                                            )}
                                        </div>
                                    </div>
                                    <div className='tab-content'>
                                        <div className={clsx('tab-pane', { active: tab === '6' })}>
                                            {carRental['policyDetail']['en_accidentAndBreakDowns'] && (
                                                <>
                                                    {/* <!--begin::Row--> */}
                                                    <div className='row mb-8'>
                                                        {/* <!--begin::Col--> */}
                                                        <div className='col-xl-3'>
                                                            <div className='fs-6 fw-bold mt-2 mb-3'>
                                                                {t('Accident And BreakDowns (English)')}
                                                            </div>
                                                        </div>
                                                        {/* <!--end::Col--> */}

                                                        {/* <!--begin::Col--> */}
                                                        <div className='col-xl-9'>
                                                            {/* <!--begin::Progress--> */}
                                                            <div className='d-flex flex-column'>
                                                                <div className=' fw-semibold text-gray-600 mt-3'>
                                                                    <div
                                                                        dangerouslySetInnerHTML={{
                                                                            __html: carRental['policyDetail']['en_accidentAndBreakDowns'],
                                                                        }}
                                                                    ></div>
                                                                </div>
                                                            </div>
                                                            {/* <!--end::Progress--> */}
                                                        </div>
                                                        {/* <!--end::Col--> */}
                                                    </div>
                                                    {/* <!--end::Row--> */}
                                                </>
                                            )}
                                            {carRental['policyDetail']['ru_accidentAndBreakDowns'] && (
                                                <>
                                                    {/* <!--begin::Row--> */}
                                                    <div className='row mb-8'>
                                                        {/* <!--begin::Col--> */}
                                                        <div className='col-xl-3'>
                                                            <div className='fs-6 fw-bold mt-2 mb-3'>
                                                                {t('Accident And BreakDowns (Russian)')}
                                                            </div>
                                                        </div>
                                                        {/* <!--end::Col--> */}

                                                        {/* <!--begin::Col--> */}
                                                        <div className='col-xl-9'>
                                                            {/* <!--begin::Progress--> */}
                                                            <div className='d-flex flex-column'>
                                                                <div className=' fw-semibold text-gray-600 mt-3'>
                                                                    <div
                                                                        dangerouslySetInnerHTML={{
                                                                            __html: carRental['policyDetail']['ru_accidentAndBreakDowns'],
                                                                        }}
                                                                    ></div>
                                                                </div>
                                                            </div>
                                                            {/* <!--end::Progress--> */}
                                                        </div>
                                                        {/* <!--end::Col--> */}
                                                    </div>
                                                    {/* <!--end::Row--> */}
                                                </>
                                            )}
                                            {carRental['policyDetail']['uz_accidentAndBreakDowns'] && (
                                                <>
                                                    {/* <!--begin::Row--> */}
                                                    <div className='row mb-8'>
                                                        {/* <!--begin::Col--> */}
                                                        <div className='col-xl-3'>
                                                            <div className='fs-6 fw-bold mt-2 mb-3'>
                                                                {t('Accident And BreakDowns (Uzbek)')}
                                                            </div>
                                                        </div>
                                                        {/* <!--end::Col--> */}

                                                        {/* <!--begin::Col--> */}
                                                        <div className='col-xl-9'>
                                                            {/* <!--begin::Progress--> */}
                                                            <div className='d-flex flex-column'>
                                                                <div className=' fw-semibold text-gray-600 mt-3'>
                                                                    <div
                                                                        dangerouslySetInnerHTML={{
                                                                            __html: carRental['policyDetail']['uz_accidentAndBreakDowns'],
                                                                        }}
                                                                    ></div>
                                                                </div>
                                                            </div>
                                                            {/* <!--end::Progress--> */}
                                                        </div>
                                                        {/* <!--end::Col--> */}
                                                    </div>
                                                    {/* <!--end::Row--> */}
                                                </>
                                            )}
                                            {carRental['policyDetail']['en_roadsideAssitance'] && (
                                                <>
                                                    {/* <!--begin::Row--> */}
                                                    <div className='row mb-8'>
                                                        {/* <!--begin::Col--> */}
                                                        <div className='col-xl-3'>
                                                            <div className='fs-6 fw-bold mt-2 mb-3'>{t('Road Side Assitance (English)')}</div>
                                                        </div>
                                                        {/* <!--end::Col--> */}

                                                        {/* <!--begin::Col--> */}
                                                        <div className='col-xl-9'>
                                                            {/* <!--begin::Progress--> */}
                                                            <div className='d-flex flex-column'>
                                                                <div className=' fw-semibold text-gray-600 mt-3'>
                                                                    <div
                                                                        dangerouslySetInnerHTML={{
                                                                            __html: carRental['policyDetail']['en_roadsideAssitance'],
                                                                        }}
                                                                    ></div>
                                                                </div>
                                                            </div>
                                                            {/* <!--end::Progress--> */}
                                                        </div>
                                                        {/* <!--end::Col--> */}
                                                    </div>
                                                    {/* <!--end::Row--> */}
                                                </>
                                            )}
                                            {carRental['policyDetail']['ru_roadsideAssitance'] && (
                                                <>
                                                    {/* <!--begin::Row--> */}
                                                    <div className='row mb-8'>
                                                        {/* <!--begin::Col--> */}
                                                        <div className='col-xl-3'>
                                                            <div className='fs-6 fw-bold mt-2 mb-3'>{t('Road Side Assitance (Russian)')}</div>
                                                        </div>
                                                        {/* <!--end::Col--> */}

                                                        {/* <!--begin::Col--> */}
                                                        <div className='col-xl-9'>
                                                            {/* <!--begin::Progress--> */}
                                                            <div className='d-flex flex-column'>
                                                                <div className=' fw-semibold text-gray-600 mt-3'>
                                                                    <div
                                                                        dangerouslySetInnerHTML={{
                                                                            __html: carRental['policyDetail']['ru_roadsideAssitance'],
                                                                        }}
                                                                    ></div>
                                                                </div>
                                                            </div>
                                                            {/* <!--end::Progress--> */}
                                                        </div>
                                                        {/* <!--end::Col--> */}
                                                    </div>
                                                    {/* <!--end::Row--> */}
                                                </>
                                            )}
                                            {carRental['policyDetail']['uz_roadsideAssitance'] && (
                                                <>
                                                    {/* <!--begin::Row--> */}
                                                    <div className='row mb-8'>
                                                        {/* <!--begin::Col--> */}
                                                        <div className='col-xl-3'>
                                                            <div className='fs-6 fw-bold mt-2 mb-3'>{t('Road Side Assitance (Uzbek)')}</div>
                                                        </div>
                                                        {/* <!--end::Col--> */}

                                                        {/* <!--begin::Col--> */}
                                                        <div className='col-xl-9'>
                                                            {/* <!--begin::Progress--> */}
                                                            <div className='d-flex flex-column'>
                                                                <div className=' fw-semibold text-gray-600 mt-3'>
                                                                    <div
                                                                        dangerouslySetInnerHTML={{
                                                                            __html: carRental['policyDetail']['uz_roadsideAssitance'],
                                                                        }}
                                                                    ></div>
                                                                </div>
                                                            </div>
                                                            {/* <!--end::Progress--> */}
                                                        </div>
                                                        {/* <!--end::Col--> */}
                                                    </div>
                                                    {/* <!--end::Row--> */}
                                                </>
                                            )}
                                            {carRental['policyDetail']['en_lostKeys'] && (
                                                <>
                                                    {/* <!--begin::Row--> */}
                                                    <div className='row mb-8'>
                                                        {/* <!--begin::Col--> */}
                                                        <div className='col-xl-3'>
                                                            <div className='fs-6 fw-bold mt-2 mb-3'>{t('Lost Keys (English)')}</div>
                                                        </div>
                                                        {/* <!--end::Col--> */}

                                                        {/* <!--begin::Col--> */}
                                                        <div className='col-xl-9'>
                                                            {/* <!--begin::Progress--> */}
                                                            <div className='d-flex flex-column'>
                                                                <div className=' fw-semibold text-gray-600 mt-3'>
                                                                    <div
                                                                        dangerouslySetInnerHTML={{
                                                                            __html: carRental['policyDetail']['en_lostKeys'],
                                                                        }}
                                                                    ></div>
                                                                </div>
                                                            </div>
                                                            {/* <!--end::Progress--> */}
                                                        </div>
                                                        {/* <!--end::Col--> */}
                                                    </div>
                                                    {/* <!--end::Row--> */}
                                                </>
                                            )}
                                            {carRental['policyDetail']['ru_lostKeys'] && (
                                                <>
                                                    {/* <!--begin::Row--> */}
                                                    <div className='row mb-8'>
                                                        {/* <!--begin::Col--> */}
                                                        <div className='col-xl-3'>
                                                            <div className='fs-6 fw-bold mt-2 mb-3'>{t('Lost Keys (Russian)')}</div>
                                                        </div>
                                                        {/* <!--end::Col--> */}

                                                        {/* <!--begin::Col--> */}
                                                        <div className='col-xl-9'>
                                                            {/* <!--begin::Progress--> */}
                                                            <div className='d-flex flex-column'>
                                                                <div className=' fw-semibold text-gray-600 mt-3'>
                                                                    <div
                                                                        dangerouslySetInnerHTML={{
                                                                            __html: carRental['policyDetail']['ru_lostKeys'],
                                                                        }}
                                                                    ></div>
                                                                </div>
                                                            </div>
                                                            {/* <!--end::Progress--> */}
                                                        </div>
                                                        {/* <!--end::Col--> */}
                                                    </div>
                                                    {/* <!--end::Row--> */}
                                                </>
                                            )}
                                            {carRental['policyDetail']['uz_lostKeys'] && (
                                                <>
                                                    {/* <!--begin::Row--> */}
                                                    <div className='row mb-8'>
                                                        {/* <!--begin::Col--> */}
                                                        <div className='col-xl-3'>
                                                            <div className='fs-6 fw-bold mt-2 mb-3'>{t('Lost Keys (Uzbek)')}</div>
                                                        </div>
                                                        {/* <!--end::Col--> */}

                                                        {/* <!--begin::Col--> */}
                                                        <div className='col-xl-9'>
                                                            {/* <!--begin::Progress--> */}
                                                            <div className='d-flex flex-column'>
                                                                <div className=' fw-semibold text-gray-600 mt-3'>
                                                                    <div
                                                                        dangerouslySetInnerHTML={{
                                                                            __html: carRental['policyDetail']['uz_lostKeys'],
                                                                        }}
                                                                    ></div>
                                                                </div>
                                                            </div>
                                                            {/* <!--end::Progress--> */}
                                                        </div>
                                                        {/* <!--end::Col--> */}
                                                    </div>
                                                    {/* <!--end::Row--> */}
                                                </>
                                            )}
                                            {carRental['policyDetail']['en_seatBelts'] && (
                                                <>
                                                    {/* <!--begin::Row--> */}
                                                    <div className='row mb-8'>
                                                        {/* <!--begin::Col--> */}
                                                        <div className='col-xl-3'>
                                                            <div className='fs-6 fw-bold mt-2 mb-3'>{t('Seat Belts (English)')}</div>
                                                        </div>
                                                        {/* <!--end::Col--> */}

                                                        {/* <!--begin::Col--> */}
                                                        <div className='col-xl-9'>
                                                            {/* <!--begin::Progress--> */}
                                                            <div className='d-flex flex-column'>
                                                                <div className=' fw-semibold text-gray-600 mt-3'>
                                                                    <div
                                                                        dangerouslySetInnerHTML={{
                                                                            __html: carRental['policyDetail']['en_seatBelts'],
                                                                        }}
                                                                    ></div>
                                                                </div>
                                                            </div>
                                                            {/* <!--end::Progress--> */}
                                                        </div>
                                                        {/* <!--end::Col--> */}
                                                    </div>
                                                    {/* <!--end::Row--> */}
                                                </>
                                            )}
                                            {carRental['policyDetail']['ru_seatBelts'] && (
                                                <>
                                                    {/* <!--begin::Row--> */}
                                                    <div className='row mb-8'>
                                                        {/* <!--begin::Col--> */}
                                                        <div className='col-xl-3'>
                                                            <div className='fs-6 fw-bold mt-2 mb-3'>{t('Seat Belts (Russian)')}</div>
                                                        </div>
                                                        {/* <!--end::Col--> */}

                                                        {/* <!--begin::Col--> */}
                                                        <div className='col-xl-9'>
                                                            {/* <!--begin::Progress--> */}
                                                            <div className='d-flex flex-column'>
                                                                <div className=' fw-semibold text-gray-600 mt-3'>
                                                                    <div
                                                                        dangerouslySetInnerHTML={{
                                                                            __html: carRental['policyDetail']['ru_seatBelts'],
                                                                        }}
                                                                    ></div>
                                                                </div>
                                                            </div>
                                                            {/* <!--end::Progress--> */}
                                                        </div>
                                                        {/* <!--end::Col--> */}
                                                    </div>
                                                    {/* <!--end::Row--> */}
                                                </>
                                            )}
                                            {carRental['policyDetail']['uz_seatBelts'] && (
                                                <>
                                                    {/* <!--begin::Row--> */}
                                                    <div className='row mb-8'>
                                                        {/* <!--begin::Col--> */}
                                                        <div className='col-xl-3'>
                                                            <div className='fs-6 fw-bold mt-2 mb-3'>{t('Seat Belts (Uzbek)')}</div>
                                                        </div>
                                                        {/* <!--end::Col--> */}

                                                        {/* <!--begin::Col--> */}
                                                        <div className='col-xl-9'>
                                                            {/* <!--begin::Progress--> */}
                                                            <div className='d-flex flex-column'>
                                                                <div className=' fw-semibold text-gray-600 mt-3'>
                                                                    <div
                                                                        dangerouslySetInnerHTML={{
                                                                            __html: carRental['policyDetail']['uz_seatBelts'],
                                                                        }}
                                                                    ></div>
                                                                </div>
                                                            </div>
                                                            {/* <!--end::Progress--> */}
                                                        </div>
                                                        {/* <!--end::Col--> */}
                                                    </div>
                                                    {/* <!--end::Row--> */}
                                                </>
                                            )}
                                            {carRental['policyDetail']['en_noSmoking'] && (
                                                <>
                                                    {/* <!--begin::Row--> */}
                                                    <div className='row mb-8'>
                                                        {/* <!--begin::Col--> */}
                                                        <div className='col-xl-3'>
                                                            <div className='fs-6 fw-bold mt-2 mb-3'>{t('No Smoking (English)')}</div>
                                                        </div>
                                                        {/* <!--end::Col--> */}

                                                        {/* <!--begin::Col--> */}
                                                        <div className='col-xl-9'>
                                                            {/* <!--begin::Progress--> */}
                                                            <div className='d-flex flex-column'>
                                                                <div className=' fw-semibold text-gray-600 mt-3'>
                                                                    <div
                                                                        dangerouslySetInnerHTML={{
                                                                            __html: carRental['policyDetail']['en_noSmoking'],
                                                                        }}
                                                                    ></div>
                                                                </div>
                                                            </div>
                                                            {/* <!--end::Progress--> */}
                                                        </div>
                                                        {/* <!--end::Col--> */}
                                                    </div>
                                                    {/* <!--end::Row--> */}
                                                </>
                                            )}
                                            {carRental['policyDetail']['ru_noSmoking'] && (
                                                <>
                                                    {/* <!--begin::Row--> */}
                                                    <div className='row mb-8'>
                                                        {/* <!--begin::Col--> */}
                                                        <div className='col-xl-3'>
                                                            <div className='fs-6 fw-bold mt-2 mb-3'>{t('No Smoking (Russian)')}</div>
                                                        </div>
                                                        {/* <!--end::Col--> */}

                                                        {/* <!--begin::Col--> */}
                                                        <div className='col-xl-9'>
                                                            {/* <!--begin::Progress--> */}
                                                            <div className='d-flex flex-column'>
                                                                <div className=' fw-semibold text-gray-600 mt-3'>
                                                                    <div
                                                                        dangerouslySetInnerHTML={{
                                                                            __html: carRental['policyDetail']['ru_noSmoking'],
                                                                        }}
                                                                    ></div>
                                                                </div>
                                                            </div>
                                                            {/* <!--end::Progress--> */}
                                                        </div>
                                                        {/* <!--end::Col--> */}
                                                    </div>
                                                    {/* <!--end::Row--> */}
                                                </>
                                            )}
                                            {carRental['policyDetail']['uz_noSmoking'] && (
                                                <>
                                                    {/* <!--begin::Row--> */}
                                                    <div className='row mb-8'>
                                                        {/* <!--begin::Col--> */}
                                                        <div className='col-xl-3'>
                                                            <div className='fs-6 fw-bold mt-2 mb-3'>{t('No Smoking (Uzbek)')}</div>
                                                        </div>
                                                        {/* <!--end::Col--> */}

                                                        {/* <!--begin::Col--> */}
                                                        <div className='col-xl-9'>
                                                            {/* <!--begin::Progress--> */}
                                                            <div className='d-flex flex-column'>
                                                                <div className=' fw-semibold text-gray-600 mt-3'>
                                                                    <div
                                                                        dangerouslySetInnerHTML={{
                                                                            __html: carRental['policyDetail']['uz_noSmoking'],
                                                                        }}
                                                                    ></div>
                                                                </div>
                                                            </div>
                                                            {/* <!--end::Progress--> */}
                                                        </div>
                                                        {/* <!--end::Col--> */}
                                                    </div>
                                                    {/* <!--end::Row--> */}
                                                </>
                                            )}
                                            {carRental['policyDetail']['en_priceCalculation'] && (
                                                <>
                                                    {/* <!--begin::Row--> */}
                                                    <div className='row mb-8'>
                                                        {/* <!--begin::Col--> */}
                                                        <div className='col-xl-3'>
                                                            <div className='fs-6 fw-bold mt-2 mb-3'>{t('Price Calculation (English)')}</div>
                                                        </div>
                                                        {/* <!--end::Col--> */}

                                                        {/* <!--begin::Col--> */}
                                                        <div className='col-xl-9'>
                                                            {/* <!--begin::Progress--> */}
                                                            <div className='d-flex flex-column'>
                                                                <div className=' fw-semibold text-gray-600 mt-3'>
                                                                    <div
                                                                        dangerouslySetInnerHTML={{
                                                                            __html: carRental['policyDetail']['en_priceCalculation'],
                                                                        }}
                                                                    ></div>
                                                                </div>
                                                            </div>
                                                            {/* <!--end::Progress--> */}
                                                        </div>
                                                        {/* <!--end::Col--> */}
                                                    </div>
                                                    {/* <!--end::Row--> */}
                                                </>
                                            )}
                                            {carRental['policyDetail']['ru_priceCalculation'] && (
                                                <>
                                                    {/* <!--begin::Row--> */}
                                                    <div className='row mb-8'>
                                                        {/* <!--begin::Col--> */}
                                                        <div className='col-xl-3'>
                                                            <div className='fs-6 fw-bold mt-2 mb-3'>{t('Price Calculation (Russian)')}</div>
                                                        </div>
                                                        {/* <!--end::Col--> */}

                                                        {/* <!--begin::Col--> */}
                                                        <div className='col-xl-9'>
                                                            {/* <!--begin::Progress--> */}
                                                            <div className='d-flex flex-column'>
                                                                <div className=' fw-semibold text-gray-600 mt-3'>
                                                                    <div
                                                                        dangerouslySetInnerHTML={{
                                                                            __html: carRental['policyDetail']['ru_priceCalculation'],
                                                                        }}
                                                                    ></div>
                                                                </div>
                                                            </div>
                                                            {/* <!--end::Progress--> */}
                                                        </div>
                                                        {/* <!--end::Col--> */}
                                                    </div>
                                                    {/* <!--end::Row--> */}
                                                </>
                                            )}
                                            {carRental['policyDetail']['uz_priceCalculation'] && (
                                                <>
                                                    {/* <!--begin::Row--> */}
                                                    <div className='row mb-8'>
                                                        {/* <!--begin::Col--> */}
                                                        <div className='col-xl-3'>
                                                            <div className='fs-6 fw-bold mt-2 mb-3'>{t('Price Calculation (Uzbek)')}</div>
                                                        </div>
                                                        {/* <!--end::Col--> */}

                                                        {/* <!--begin::Col--> */}
                                                        <div className='col-xl-9'>
                                                            {/* <!--begin::Progress--> */}
                                                            <div className='d-flex flex-column'>
                                                                <div className=' fw-semibold text-gray-600 mt-3'>
                                                                    <div
                                                                        dangerouslySetInnerHTML={{
                                                                            __html: carRental['policyDetail']['uz_priceCalculation'],
                                                                        }}
                                                                    ></div>
                                                                </div>
                                                            </div>
                                                            {/* <!--end::Progress--> */}
                                                        </div>
                                                        {/* <!--end::Col--> */}
                                                    </div>
                                                    {/* <!--end::Row--> */}
                                                </>
                                            )}
                                            {carRental['policyDetail']['en_violations'] && (
                                                <>
                                                    {/* <!--begin::Row--> */}
                                                    <div className='row mb-8'>
                                                        {/* <!--begin::Col--> */}
                                                        <div className='col-xl-3'>
                                                            <div className='fs-6 fw-bold mt-2 mb-3'>{t('Violations (English)')}</div>
                                                        </div>
                                                        {/* <!--end::Col--> */}

                                                        {/* <!--begin::Col--> */}
                                                        <div className='col-xl-9'>
                                                            {/* <!--begin::Progress--> */}
                                                            <div className='d-flex flex-column'>
                                                                <div className=' fw-semibold text-gray-600 mt-3'>
                                                                    <div
                                                                        dangerouslySetInnerHTML={{
                                                                            __html: carRental['policyDetail']['en_violations'],
                                                                        }}
                                                                    ></div>
                                                                </div>
                                                            </div>
                                                            {/* <!--end::Progress--> */}
                                                        </div>
                                                        {/* <!--end::Col--> */}
                                                    </div>
                                                    {/* <!--end::Row--> */}
                                                </>
                                            )}
                                            {carRental['policyDetail']['ru_violations'] && (
                                                <>
                                                    {/* <!--begin::Row--> */}
                                                    <div className='row mb-8'>
                                                        {/* <!--begin::Col--> */}
                                                        <div className='col-xl-3'>
                                                            <div className='fs-6 fw-bold mt-2 mb-3'>{t('Violations (Russian)')}</div>
                                                        </div>
                                                        {/* <!--end::Col--> */}

                                                        {/* <!--begin::Col--> */}
                                                        <div className='col-xl-9'>
                                                            {/* <!--begin::Progress--> */}
                                                            <div className='d-flex flex-column'>
                                                                <div className=' fw-semibold text-gray-600 mt-3'>
                                                                    <div
                                                                        dangerouslySetInnerHTML={{
                                                                            __html: carRental['policyDetail']['ru_violations'],
                                                                        }}
                                                                    ></div>
                                                                </div>
                                                            </div>
                                                            {/* <!--end::Progress--> */}
                                                        </div>
                                                        {/* <!--end::Col--> */}
                                                    </div>
                                                    {/* <!--end::Row--> */}
                                                </>
                                            )}
                                            {carRental['policyDetail']['uz_violations'] && (
                                                <>
                                                    {/* <!--begin::Row--> */}
                                                    <div className='row mb-8'>
                                                        {/* <!--begin::Col--> */}
                                                        <div className='col-xl-3'>
                                                            <div className='fs-6 fw-bold mt-2 mb-3'>{t('Violations (Uzbek)')}</div>
                                                        </div>
                                                        {/* <!--end::Col--> */}

                                                        {/* <!--begin::Col--> */}
                                                        <div className='col-xl-9'>
                                                            {/* <!--begin::Progress--> */}
                                                            <div className='d-flex flex-column'>
                                                                <div className=' fw-semibold text-gray-600 mt-3'>
                                                                    <div
                                                                        dangerouslySetInnerHTML={{
                                                                            __html: carRental['policyDetail']['uz_violations'],
                                                                        }}
                                                                    ></div>
                                                                </div>
                                                            </div>
                                                            {/* <!--end::Progress--> */}
                                                        </div>
                                                        {/* <!--end::Col--> */}
                                                    </div>
                                                    {/* <!--end::Row--> */}
                                                </>
                                            )}
                                            {carRental['policyDetail']['en_travelRestrications'] && (
                                                <>
                                                    {/* <!--begin::Row--> */}
                                                    <div className='row mb-8'>
                                                        {/* <!--begin::Col--> */}
                                                        <div className='col-xl-3'>
                                                            <div className='fs-6 fw-bold mt-2 mb-3'>{t('Travel Restrications (English)')}</div>
                                                        </div>
                                                        {/* <!--end::Col--> */}

                                                        {/* <!--begin::Col--> */}
                                                        <div className='col-xl-9'>
                                                            {/* <!--begin::Progress--> */}
                                                            <div className='d-flex flex-column'>
                                                                <div className=' fw-semibold text-gray-600 mt-3'>
                                                                    <div
                                                                        dangerouslySetInnerHTML={{
                                                                            __html: carRental['policyDetail']['en_travelRestrications'],
                                                                        }}
                                                                    ></div>
                                                                </div>
                                                            </div>
                                                            {/* <!--end::Progress--> */}
                                                        </div>
                                                        {/* <!--end::Col--> */}
                                                    </div>
                                                    {/* <!--end::Row--> */}
                                                </>
                                            )}
                                            {carRental['policyDetail']['ru_travelRestrications'] && (
                                                <>
                                                    {/* <!--begin::Row--> */}
                                                    <div className='row mb-8'>
                                                        {/* <!--begin::Col--> */}
                                                        <div className='col-xl-3'>
                                                            <div className='fs-6 fw-bold mt-2 mb-3'>{t('Travel Restrications (Russian)')}</div>
                                                        </div>
                                                        {/* <!--end::Col--> */}

                                                        {/* <!--begin::Col--> */}
                                                        <div className='col-xl-9'>
                                                            {/* <!--begin::Progress--> */}
                                                            <div className='d-flex flex-column'>
                                                                <div className=' fw-semibold text-gray-600 mt-3'>
                                                                    <div
                                                                        dangerouslySetInnerHTML={{
                                                                            __html: carRental['policyDetail']['ru_travelRestrications'],
                                                                        }}
                                                                    ></div>
                                                                </div>
                                                            </div>
                                                            {/* <!--end::Progress--> */}
                                                        </div>
                                                        {/* <!--end::Col--> */}
                                                    </div>
                                                    {/* <!--end::Row--> */}
                                                </>
                                            )}
                                            {carRental['policyDetail']['uz_travelRestrications'] && (
                                                <>
                                                    {/* <!--begin::Row--> */}
                                                    <div className='row mb-8'>
                                                        {/* <!--begin::Col--> */}
                                                        <div className='col-xl-3'>
                                                            <div className='fs-6 fw-bold mt-2 mb-3'>{t('Travel Restrications (Uzbek)')}</div>
                                                        </div>
                                                        {/* <!--end::Col--> */}

                                                        {/* <!--begin::Col--> */}
                                                        <div className='col-xl-9'>
                                                            {/* <!--begin::Progress--> */}
                                                            <div className='d-flex flex-column'>
                                                                <div className=' fw-semibold text-gray-600 mt-3'>
                                                                    <div
                                                                        dangerouslySetInnerHTML={{
                                                                            __html: carRental['policyDetail']['uz_travelRestrications'],
                                                                        }}
                                                                    ></div>
                                                                </div>
                                                            </div>
                                                            {/* <!--end::Progress--> */}
                                                        </div>
                                                        {/* <!--end::Col--> */}
                                                    </div>
                                                    {/* <!--end::Row--> */}
                                                </>
                                            )}
                                        </div>
                                    </div>
                                    <div className='tab-content'>
                                        <div className={clsx('tab-pane', { active: tab === '7' })}>
                                            {carRental['policyDetail']['customPolicy'] && carRental['policyDetail']['customPolicy'].length != 0 && (
                                                <>
                                                    {carRental['policyDetail']['customPolicy'].map(
                                                        (customPolicy: any, index: any) => {
                                                            return (
                                                                <div key={index}>
                                                                    {customPolicy['en_title'] && (
                                                                        <div className='row mb-8'>
                                                                            {/* <!--begin::Col--> */}
                                                                            <div className='col-xl-3'>
                                                                                <div className='fs-6 fw-bold mt-2 mb-3'>
                                                                                    {customPolicy['en_title']} (English)
                                                                                </div>
                                                                            </div>
                                                                            {/* <!--end::Col--> */}

                                                                            {/* <!--begin::Col--> */}
                                                                            <div className='col-xl-9'>
                                                                                {/* <!--begin::Progress--> */}
                                                                                <div className='d-flex flex-column'>
                                                                                    <div className=' fw-semibold text-gray-600 mt-3'>
                                                                                        <div
                                                                                            dangerouslySetInnerHTML={{
                                                                                                __html: customPolicy['en_description'],
                                                                                            }}
                                                                                        ></div>
                                                                                    </div>
                                                                                </div>
                                                                                {/* <!--end::Progress--> */}
                                                                            </div>
                                                                            {/* <!--end::Col--> */}
                                                                        </div>
                                                                    )}
                                                                    {customPolicy['ru_title'] && (
                                                                        <div className='row mb-8'>
                                                                            {/* <!--begin::Col--> */}
                                                                            <div className='col-xl-3'>
                                                                                <div className='fs-6 fw-bold mt-2 mb-3'>
                                                                                    {customPolicy['ru_title']} (Russian)
                                                                                </div>
                                                                            </div>
                                                                            {/* <!--end::Col--> */}

                                                                            {/* <!--begin::Col--> */}
                                                                            <div className='col-xl-9'>
                                                                                {/* <!--begin::Progress--> */}
                                                                                <div className='d-flex flex-column'>
                                                                                    <div className=' fw-semibold text-gray-600 mt-3'>
                                                                                        <div
                                                                                            dangerouslySetInnerHTML={{
                                                                                                __html: customPolicy['ru_description'],
                                                                                            }}
                                                                                        ></div>
                                                                                    </div>
                                                                                </div>
                                                                                {/* <!--end::Progress--> */}
                                                                            </div>
                                                                            {/* <!--end::Col--> */}
                                                                        </div>
                                                                    )}
                                                                    {customPolicy['uz_title'] && (
                                                                        <div className='row mb-8'>
                                                                            {/* <!--begin::Col--> */}
                                                                            <div className='col-xl-3'>
                                                                                <div className='fs-6 fw-bold mt-2 mb-3'>
                                                                                    {customPolicy['uz_title']} (Uzbek)
                                                                                </div>
                                                                            </div>
                                                                            {/* <!--end::Col--> */}

                                                                            {/* <!--begin::Col--> */}
                                                                            <div className='col-xl-9'>
                                                                                {/* <!--begin::Progress--> */}
                                                                                <div className='d-flex flex-column'>
                                                                                    <div className=' fw-semibold text-gray-600 mt-3'>
                                                                                        <div
                                                                                            dangerouslySetInnerHTML={{
                                                                                                __html: customPolicy['uz_description'],
                                                                                            }}
                                                                                        ></div>
                                                                                    </div>
                                                                                </div>
                                                                                {/* <!--end::Progress--> */}
                                                                            </div>
                                                                            {/* <!--end::Col--> */}
                                                                        </div>
                                                                    )}
                                                                </div>
                                                            )
                                                        }
                                                    )}
                                                </>
                                            )}
                                        </div>
                                    </div>
                                </div>

                {carRental['ownerName'] != '' ? (
                  <div className='col-xl-3 border-bottom border-light border-2 w-100 mb-5 mt-5'>
                    <div className='fs-3 fw-bold mb-5 '>{t('Finance & Legal Information')}</div>
                  </div>
                ) : (
                  ''
                )}
                {carRental['ownerName'] && (
                  <div className='row mb-8'>
                    {/* <!--begin::Col--> */}
                    <div className='col-xl-3'>
                      <div className='fs-6 fw-bold mt-2 mb-3'>{t('Owner Name')}</div>
                    </div>
                    {/* <!--end::Col--> */}

                    {/* <!--begin::Col--> */}
                    <div className='col-xl-9'>
                      {/* <!--begin::Progress--> */}
                      <div className='d-flex flex-column'>
                        <div className=' fw-semibold text-gray-600 mt-3'>
                          <div
                            dangerouslySetInnerHTML={{
                              __html: carRental['ownerName'],
                            }}
                          ></div>
                        </div>
                      </div>
                      {/* <!--end::Progress--> */}
                    </div>
                    {/* <!--end::Col--> */}
                  </div>
                )}
                {carRental['passportNumber'] && (
                  <div className='row mb-8'>
                    {/* <!--begin::Col--> */}
                    <div className='col-xl-3'>
                      <div className='fs-6 fw-bold mt-2 mb-3'>{t('Passport Number')}</div>
                    </div>
                    {/* <!--end::Col--> */}

                    {/* <!--begin::Col--> */}
                    <div className='col-xl-9'>
                      {/* <!--begin::Progress--> */}
                      <div className='d-flex flex-column'>
                        <div className=' fw-semibold text-gray-600 mt-3'>
                          <div
                            dangerouslySetInnerHTML={{
                              __html: carRental['passportNumber'],
                            }}
                          ></div>
                        </div>
                      </div>
                      {/* <!--end::Progress--> */}
                    </div>
                    {/* <!--end::Col--> */}
                  </div>
                )}
                {carRental['jShShIR'] && (
                  <div className='row mb-8'>
                    {/* <!--begin::Col--> */}
                    <div className='col-xl-3'>
                      <div className='fs-6 fw-bold mt-2 mb-3'>{t('JShShIR (ПИНФЛ)')}</div>
                    </div>
                    {/* <!--end::Col--> */}

                    {/* <!--begin::Col--> */}
                    <div className='col-xl-9'>
                      {/* <!--begin::Progress--> */}
                      <div className='d-flex flex-column'>
                        <div className=' fw-semibold text-gray-600 mt-3'>
                          <div
                            dangerouslySetInnerHTML={{
                              __html: carRental['jShShIR'],
                            }}
                          ></div>
                        </div>
                      </div>
                      {/* <!--end::Progress--> */}
                    </div>
                    {/* <!--end::Col--> */}
                  </div>
                )}
                {carRental['businessName'] && (
                  <div className='row mb-8'>
                    {/* <!--begin::Col--> */}
                    <div className='col-xl-3'>
                      <div className='fs-6 fw-bold mt-2 mb-3'>{t('Business Name')}</div>
                    </div>
                    {/* <!--end::Col--> */}

                    {/* <!--begin::Col--> */}
                    <div className='col-xl-9'>
                      {/* <!--begin::Progress--> */}
                      <div className='d-flex flex-column'>
                        <div className=' fw-semibold text-gray-600 mt-3'>
                          <div
                            dangerouslySetInnerHTML={{
                              __html: carRental['businessName'],
                            }}
                          ></div>
                        </div>
                      </div>
                      {/* <!--end::Progress--> */}
                    </div>
                    {/* <!--end::Col--> */}
                  </div>
                )}
                {carRental['businessSTIR'] && (
                  <div className='row mb-8'>
                    {/* <!--begin::Col--> */}
                    <div className='col-xl-3'>
                      <div className='fs-6 fw-bold mt-2 mb-3'>{t('Business STIR')}</div>
                    </div>
                    {/* <!--end::Col--> */}

                    {/* <!--begin::Col--> */}
                    <div className='col-xl-9'>
                      {/* <!--begin::Progress--> */}
                      <div className='d-flex flex-column'>
                        <div className=' fw-semibold text-gray-600 mt-3'>
                          <div
                            dangerouslySetInnerHTML={{
                              __html: carRental['businessSTIR'],
                            }}
                          ></div>
                        </div>
                      </div>
                      {/* <!--end::Progress--> */}
                    </div>
                    {/* <!--end::Col--> */}
                  </div>
                )}
                {carRental['qqs'] && selectedQqs ? (
                  <>
                    {/* <!--begin::Row--> */}
                    <div className='row mb-8'>
                      {/* <!--begin::Col--> */}
                      <div className='col-xl-3'>
                        <div className='fs-6 fw-bold mt-2 mb-3'>{t('QQS')}</div>
                      </div>
                      {/* <!--end::Col--> */}

                      {/* <!--begin::Col--> */}
                      <div className='col-xl-9'>
                        {/* <!--begin::Progress--> */}
                        <div className='d-flex flex-column'>
                          <div className=' fw-semibold text-gray-600 mt-3'>
                            <div dangerouslySetInnerHTML={{__html: selectedQqs.label}}></div>
                          </div>
                        </div>
                        {/* <!--end::Progress--> */}
                      </div>
                      {/* <!--end::Col--> */}
                    </div>
                    {/* <!--end::Row--> */}
                  </>
                ) : (
                  ''
                )}

                {carRental['mxikkodi'] ? (
                  <>
                    {/* <!--begin::Row--> */}
                    <div className='row mb-8'>
                      {/* <!--begin::Col--> */}
                      <div className='col-xl-3'>
                        <div className='fs-6 fw-bold mt-2 mb-3'>{t('MXIK kodi')}</div>
                      </div>

                      <div className='col-xl-9'>
                        <div className='d-flex flex-column'>
                          <div className=' fw-semibold text-gray-600 mt-3'>
                            <div dangerouslySetInnerHTML={{__html: carRental['mxikkodi']}}></div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </>
                ) : (
                  ''
                )}
                {carRental['oIchovBirligi'] ? (
                  <>
                    <div className='row mb-8'>
                      {/* <!--begin::Col--> */}
                      <div className='col-xl-3'>
                        <div className='fs-6 fw-bold mt-2 mb-3'>{t("O'Ichov Birligi")}</div>
                      </div>
                      {/* <!--end::Col--> */}

                      {/* <!--begin::Col--> */}
                      <div className='col-xl-9'>
                        {/* <!--begin::Progress--> */}
                        <div className='d-flex flex-column'>
                          <div className=' fw-semibold text-gray-600 mt-3'>
                            <div
                              dangerouslySetInnerHTML={{__html: carRental['oIchovBirligi']}}
                            ></div>
                          </div>
                        </div>
                        {/* <!--end::Progress--> */}
                      </div>
                      {/* <!--end::Col--> */}
                    </div>
                    {/* <!--end::Row--> */}
                  </>
                ) : (
                  ''
                )}
                {carRental['bankName'] && (
                  <div className='row mb-8'>
                    {/* <!--begin::Col--> */}
                    <div className='col-xl-3'>
                      <div className='fs-6 fw-bold mt-2 mb-3'>{t('Bank Name')}</div>
                    </div>
                    {/* <!--end::Col--> */}

                    {/* <!--begin::Col--> */}
                    <div className='col-xl-9'>
                      {/* <!--begin::Progress--> */}
                      <div className='d-flex flex-column'>
                        <div className=' fw-semibold text-gray-600 mt-3'>
                          <div
                            dangerouslySetInnerHTML={{
                              __html: carRental['bankName'],
                            }}
                          ></div>
                        </div>
                      </div>
                      {/* <!--end::Progress--> */}
                    </div>
                    {/* <!--end::Col--> */}
                  </div>
                )}
                {carRental['branchName'] && (
                  <div className='row mb-8'>
                    {/* <!--begin::Col--> */}
                    <div className='col-xl-3'>
                      <div className='fs-6 fw-bold mt-2 mb-3'>{t('Branch Name')}</div>
                    </div>
                    {/* <!--end::Col--> */}

                    {/* <!--begin::Col--> */}
                    <div className='col-xl-9'>
                      {/* <!--begin::Progress--> */}
                      <div className='d-flex flex-column'>
                        <div className=' fw-semibold text-gray-600 mt-3'>
                          <div
                            dangerouslySetInnerHTML={{
                              __html: carRental['branchName'],
                            }}
                          ></div>
                        </div>
                      </div>
                      {/* <!--end::Progress--> */}
                    </div>
                    {/* <!--end::Col--> */}
                  </div>
                )}
                {carRental['accountName'] && (
                  <div className='row mb-8'>
                    {/* <!--begin::Col--> */}
                    <div className='col-xl-3'>
                      <div className='fs-6 fw-bold mt-2 mb-3'>{t('Account Name')}</div>
                    </div>
                    {/* <!--end::Col--> */}

                    {/* <!--begin::Col--> */}
                    <div className='col-xl-9'>
                      {/* <!--begin::Progress--> */}
                      <div className='d-flex flex-column'>
                        <div className=' fw-semibold text-gray-600 mt-3'>
                          <div
                            dangerouslySetInnerHTML={{
                              __html: carRental['accountName'],
                            }}
                          ></div>
                        </div>
                      </div>
                      {/* <!--end::Progress--> */}
                    </div>
                    {/* <!--end::Col--> */}
                  </div>
                )}
                {carRental['accountNumber'] && (
                  <div className='row mb-8'>
                    {/* <!--begin::Col--> */}
                    <div className='col-xl-3'>
                      <div className='fs-6 fw-bold mt-2 mb-3'>{t('Account Number')}</div>
                    </div>
                    {/* <!--end::Col--> */}

                    {/* <!--begin::Col--> */}
                    <div className='col-xl-9'>
                      {/* <!--begin::Progress--> */}
                      <div className='d-flex flex-column'>
                        <div className=' fw-semibold text-gray-600 mt-3'>
                          <div
                            dangerouslySetInnerHTML={{
                              __html: carRental['accountNumber'],
                            }}
                          ></div>
                        </div>
                      </div>
                      {/* <!--end::Progress--> */}
                    </div>
                    {/* <!--end::Col--> */}
                  </div>
                )}
                {carRental['mfo'] && (
                  <div className='row mb-8'>
                    {/* <!--begin::Col--> */}
                    <div className='col-xl-3'>
                      <div className='fs-6 fw-bold mt-2 mb-3'>{t('MFO')}</div>
                    </div>
                    {/* <!--end::Col--> */}

                    {/* <!--begin::Col--> */}
                    <div className='col-xl-9'>
                      {/* <!--begin::Progress--> */}
                      <div className='d-flex flex-column'>
                        <div className=' fw-semibold text-gray-600 mt-3'>
                          <div
                            dangerouslySetInnerHTML={{
                              __html: carRental['mfo'],
                            }}
                          ></div>
                        </div>
                      </div>
                      {/* <!--end::Progress--> */}
                    </div>
                    {/* <!--end::Col--> */}
                  </div>
                )}
                {carRental['stir'] && (
                  <div className='row mb-8'>
                    {/* <!--begin::Col--> */}
                    <div className='col-xl-3'>
                      <div className='fs-6 fw-bold mt-2 mb-3'>{t('STIR')}</div>
                    </div>
                    {/* <!--end::Col--> */}

                    {/* <!--begin::Col--> */}
                    <div className='col-xl-9'>
                      {/* <!--begin::Progress--> */}
                      <div className='d-flex flex-column'>
                        <div className=' fw-semibold text-gray-600 mt-3'>
                          <div
                            dangerouslySetInnerHTML={{
                              __html: carRental['stir'],
                            }}
                          ></div>
                        </div>
                      </div>
                      {/* <!--end::Progress--> */}
                    </div>
                    {/* <!--end::Col--> */}
                  </div>
                )}

                <div className='row align-items-end h-100 gx-5 gx-xl-10'>
                  {carRental['businessDocument'] != '' ? (
                    <Fancybox options={opts}>
                      {/* <!--begin::Col--> */}
                      <div className='col-md-4 mb-11 mb-md-0' key={index}>
                        {/* <!--begin::Overlay--> */}
                        <a
                          data-fancybox='gallery'
                          className='d-block overlay'
                          data-fslightbox='lightbox-hot-sales'
                          href={carRental['businessDocument']}
                        >
                          <div
                            className='overlay-wrapper bgi-position-center bgi-no-repeat bgi-size-cover h-200px card-rounded mb-3'
                            style={{
                              height: '266px',
                              backgroundImage: `url('${carRental['businessDocument']}')`,
                            }}
                          ></div>
                          {/* <!--end::Image--> */}

                          {/* <!--begin::Action--> */}
                          <div className='overlay-layer card-rounded bg-dark bg-opacity-25'>
                            <i className='ki-outline ki-eye fs-3x text-white'></i>
                          </div>
                          {/* <!--end::Action-->       */}
                        </a>
                        {/* <!--end::Overlay-->          */}
                      </div>
                      {/* <!--end::Col-->      */}
                    </Fancybox>
                  ) : (
                    ''
                  )}
                  {carRental['idProofDocument'] != '' ? (
                    <Fancybox options={opts}>
                      {/* <!--begin::Col--> */}
                      <div className='col-md-4 mb-11 mb-md-0' key={index}>
                        {/* <!--begin::Overlay--> */}
                        <a
                          data-fancybox='gallery'
                          className='d-block overlay'
                          data-fslightbox='lightbox-hot-sales'
                          href={carRental['idProofDocument']}
                        >
                          <div
                            className='overlay-wrapper bgi-position-center bgi-no-repeat bgi-size-cover h-200px card-rounded mb-3'
                            style={{
                              height: '266px',
                              backgroundImage: `url('${carRental['idProofDocument']}')`,
                            }}
                          ></div>
                          {/* <!--end::Image--> */}
                          {/* <!--begin::Action--> */}
                          <div className='overlay-layer card-rounded bg-dark bg-opacity-25'>
                            <i className='ki-outline ki-eye fs-3x text-white'></i>
                          </div>
                          {/* <!--end::Action-->       */}
                        </a>
                        {/* <!--end::Overlay-->          */}
                      </div>
                      {/* <!--end::Col-->      */}
                    </Fancybox>
                  ) : (
                    ''
                  )}
                </div>
                <div className='col-xl-3 border-bottom border-light border-2 w-100 mb-5 mt-5'>
                  <div className='fs-3 fw-bold mb-5 '>{t('Car Rental Images')}</div>
                </div>
                {carRental['images'] && carRental['images'].length != 0 ? (
                  <div className='col-xl-12'>
                    {/* <!--begin::Engage widget 7--> */}
                    <div className='card card-flush h-xl-100'>
                      <div className='pt-7'>
                        <div className='row align-items-end h-100 gx-5 gx-xl-10'>
                          {carRental['images'].map((images: any, index: any) => {
                            return (
                              <>
                                <Fancybox options={opts}>
                                  {/* <!--begin::Col--> */}
                                  <div className='col-md-4 mb-11 mb-md-0' key={index}>
                                    {/* <!--begin::Overlay--> */}
                                    <a
                                      data-fancybox='gallery'
                                      className='d-block overlay'
                                      data-fslightbox='lightbox-hot-sales'
                                      href={images['mediaPath']}
                                    >
                                      <div
                                        className='overlay-wrapper bgi-position-center bgi-no-repeat bgi-size-cover h-200px card-rounded mb-3'
                                        style={{
                                          height: '266px',
                                          backgroundImage: `url('${images['mediaPath']}')`,
                                        }}
                                      ></div>
                                      {/* <!--end::Image--> */}

                                      {/* <!--begin::Action--> */}
                                      <div className='overlay-layer card-rounded bg-dark bg-opacity-25'>
                                        <i className='ki-outline ki-eye fs-3x text-white'></i>{' '}
                                      </div>
                                      {/* <!--end::Action-->       */}
                                    </a>
                                    {/* <!--end::Overlay-->          */}
                                  </div>
                                  {/* <!--end::Col-->      */}
                                </Fancybox>
                              </>
                            )
                          })}
                        </div>
                        {/* <!--end::Row--> */}
                      </div>
                      {/* <!--end::Card body--> */}
                    </div>
                    {/* <!--end::Engage widget 7--> */}
                  </div>
                ) : (
                  <div className='col-xl-12'>
                    {/* <!--begin::Engage widget 1--> */}
                    <div className='card h-md-100' dir='ltr'>
                      {/* <!--begin::Body--> */}
                      <div className='card-body d-flex flex-column flex-center'>
                        {/* <!--begin::Heading--> */}
                        <div className='mb-2'>
                          {/* <!--begin::Illustration--> */}
                          <div className='py-10 text-center'>
                            <img
                              src={toAbsoluteUrl('/media/svg/illustrations/easy/2.svg')}
                              className='theme-light-show h-125px'
                              alt=''
                            />
                            <img
                              src={toAbsoluteUrl('/media/svg/illustrations/easy/2-dark.svg')}
                              className='theme-dark-show h-125px'
                              alt=''
                            />
                          </div>
                          {/* <!--end::Illustration--> */}
                        </div>
                        {/* <!--end::Heading--> */}
                      </div>
                      {/* <!--end::Body--> */}
                    </div>
                    {/* <!--end::Engage widget 1--> */}
                  </div>
                )}
              </div>
            </div>
            {/* <!--end::Card--> */}
          </div>
        )
      })}
    </>
  )
}

export {CarRentalOverview}
